(function () {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
/**
 *  lithtml
 */ /**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $0585bced692c3b45$var$t;
const $0585bced692c3b45$var$i = window, $0585bced692c3b45$var$s = $0585bced692c3b45$var$i.trustedTypes, $0585bced692c3b45$var$e = $0585bced692c3b45$var$s ? $0585bced692c3b45$var$s.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $0585bced692c3b45$var$o = "$lit$", $0585bced692c3b45$var$n = `lit$${(Math.random() + "").slice(9)}$`, $0585bced692c3b45$var$l = "?" + $0585bced692c3b45$var$n, $0585bced692c3b45$var$h = `<${$0585bced692c3b45$var$l}>`, $0585bced692c3b45$var$r = document, $0585bced692c3b45$var$u = ()=>$0585bced692c3b45$var$r.createComment(""), $0585bced692c3b45$var$d = (t)=>null === t || "object" != typeof t && "function" != typeof t, $0585bced692c3b45$var$c = Array.isArray, $0585bced692c3b45$var$v = (t)=>$0585bced692c3b45$var$c(t) || "function" == typeof (null == t ? void 0 : t[Symbol.iterator]), $0585bced692c3b45$var$a = "[ 	\n\f\r]", $0585bced692c3b45$var$f = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $0585bced692c3b45$var$_ = /-->/g, $0585bced692c3b45$var$m = />/g, $0585bced692c3b45$var$p = RegExp(`>|${$0585bced692c3b45$var$a}(?:([^\\s"'>=/]+)(${$0585bced692c3b45$var$a}*=${$0585bced692c3b45$var$a}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $0585bced692c3b45$var$g = /'/g, $0585bced692c3b45$var$$ = /"/g, $0585bced692c3b45$var$y = /^(?:script|style|textarea|title)$/i, $0585bced692c3b45$var$w = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $0585bced692c3b45$export$c0bb0b647f701bb5 = $0585bced692c3b45$var$w(1), $0585bced692c3b45$export$7ed1367e7fa1ad68 = $0585bced692c3b45$var$w(2), $0585bced692c3b45$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $0585bced692c3b45$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $0585bced692c3b45$var$E = new WeakMap, $0585bced692c3b45$var$C = $0585bced692c3b45$var$r.createTreeWalker($0585bced692c3b45$var$r, 129, null, !1);
function $0585bced692c3b45$var$P(t, i) {
    if (!Array.isArray(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $0585bced692c3b45$var$e ? $0585bced692c3b45$var$e.createHTML(i) : i;
}
const $0585bced692c3b45$var$V = (t, i)=>{
    const s = t.length - 1, e = [];
    let l, r = 2 === i ? "<svg>" : "", u = $0585bced692c3b45$var$f;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let d, c, v = -1, a = 0;
        for(; a < s.length && (u.lastIndex = a, c = u.exec(s), null !== c);)a = u.lastIndex, u === $0585bced692c3b45$var$f ? "!--" === c[1] ? u = $0585bced692c3b45$var$_ : void 0 !== c[1] ? u = $0585bced692c3b45$var$m : void 0 !== c[2] ? ($0585bced692c3b45$var$y.test(c[2]) && (l = RegExp("</" + c[2], "g")), u = $0585bced692c3b45$var$p) : void 0 !== c[3] && (u = $0585bced692c3b45$var$p) : u === $0585bced692c3b45$var$p ? ">" === c[0] ? (u = null != l ? l : $0585bced692c3b45$var$f, v = -1) : void 0 === c[1] ? v = -2 : (v = u.lastIndex - c[2].length, d = c[1], u = void 0 === c[3] ? $0585bced692c3b45$var$p : '"' === c[3] ? $0585bced692c3b45$var$$ : $0585bced692c3b45$var$g) : u === $0585bced692c3b45$var$$ || u === $0585bced692c3b45$var$g ? u = $0585bced692c3b45$var$p : u === $0585bced692c3b45$var$_ || u === $0585bced692c3b45$var$m ? u = $0585bced692c3b45$var$f : (u = $0585bced692c3b45$var$p, l = void 0);
        const w = u === $0585bced692c3b45$var$p && t[i + 1].startsWith("/>") ? " " : "";
        r += u === $0585bced692c3b45$var$f ? s + $0585bced692c3b45$var$h : v >= 0 ? (e.push(d), s.slice(0, v) + $0585bced692c3b45$var$o + s.slice(v) + $0585bced692c3b45$var$n + w) : s + $0585bced692c3b45$var$n + (-2 === v ? (e.push(void 0), i) : w);
    }
    return [
        $0585bced692c3b45$var$P(t, r + (t[s] || "<?>") + (2 === i ? "</svg>" : "")),
        e
    ];
};
class $0585bced692c3b45$var$N {
    constructor({ strings: t, _$litType$: i }, e){
        let h;
        this.parts = [];
        let r = 0, d = 0;
        const c = t.length - 1, v = this.parts, [a, f] = $0585bced692c3b45$var$V(t, i);
        if (this.el = $0585bced692c3b45$var$N.createElement(a, e), $0585bced692c3b45$var$C.currentNode = this.el.content, 2 === i) {
            const t = this.el.content, i = t.firstChild;
            i.remove(), t.append(...i.childNodes);
        }
        for(; null !== (h = $0585bced692c3b45$var$C.nextNode()) && v.length < c;){
            if (1 === h.nodeType) {
                if (h.hasAttributes()) {
                    const t = [];
                    for (const i of h.getAttributeNames())if (i.endsWith($0585bced692c3b45$var$o) || i.startsWith($0585bced692c3b45$var$n)) {
                        const s = f[d++];
                        if (t.push(i), void 0 !== s) {
                            const t = h.getAttribute(s.toLowerCase() + $0585bced692c3b45$var$o).split($0585bced692c3b45$var$n), i = /([.?@])?(.*)/.exec(s);
                            v.push({
                                type: 1,
                                index: r,
                                name: i[2],
                                strings: t,
                                ctor: "." === i[1] ? $0585bced692c3b45$var$H : "?" === i[1] ? $0585bced692c3b45$var$L : "@" === i[1] ? $0585bced692c3b45$var$z : $0585bced692c3b45$var$k
                            });
                        } else v.push({
                            type: 6,
                            index: r
                        });
                    }
                    for (const i of t)h.removeAttribute(i);
                }
                if ($0585bced692c3b45$var$y.test(h.tagName)) {
                    const t = h.textContent.split($0585bced692c3b45$var$n), i = t.length - 1;
                    if (i > 0) {
                        h.textContent = $0585bced692c3b45$var$s ? $0585bced692c3b45$var$s.emptyScript : "";
                        for(let s = 0; s < i; s++)h.append(t[s], $0585bced692c3b45$var$u()), $0585bced692c3b45$var$C.nextNode(), v.push({
                            type: 2,
                            index: ++r
                        });
                        h.append(t[i], $0585bced692c3b45$var$u());
                    }
                }
            } else if (8 === h.nodeType) {
                if (h.data === $0585bced692c3b45$var$l) v.push({
                    type: 2,
                    index: r
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = h.data.indexOf($0585bced692c3b45$var$n, t + 1));)v.push({
                        type: 7,
                        index: r
                    }), t += $0585bced692c3b45$var$n.length - 1;
                }
            }
            r++;
        }
    }
    static createElement(t, i) {
        const s = $0585bced692c3b45$var$r.createElement("template");
        return s.innerHTML = t, s;
    }
}
function $0585bced692c3b45$var$S(t, i, s = t, e) {
    var o, n, l, h;
    if (i === $0585bced692c3b45$export$9c068ae9cc5db4e8) return i;
    let r = void 0 !== e ? null === (o = s._$Co) || void 0 === o ? void 0 : o[e] : s._$Cl;
    const u = $0585bced692c3b45$var$d(i) ? void 0 : i._$litDirective$;
    return (null == r ? void 0 : r.constructor) !== u && (null === (n = null == r ? void 0 : r._$AO) || void 0 === n || n.call(r, !1), void 0 === u ? r = void 0 : (r = new u(t), r._$AT(t, s, e)), void 0 !== e ? (null !== (l = (h = s)._$Co) && void 0 !== l ? l : h._$Co = [])[e] = r : s._$Cl = r), void 0 !== r && (i = $0585bced692c3b45$var$S(t, r._$AS(t, i.values), r, e)), i;
}
class $0585bced692c3b45$var$M {
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        var i;
        const { el: { content: s }, parts: e } = this._$AD, o = (null !== (i = null == t ? void 0 : t.creationScope) && void 0 !== i ? i : $0585bced692c3b45$var$r).importNode(s, !0);
        $0585bced692c3b45$var$C.currentNode = o;
        let n = $0585bced692c3b45$var$C.nextNode(), l = 0, h = 0, u = e[0];
        for(; void 0 !== u;){
            if (l === u.index) {
                let i;
                2 === u.type ? i = new $0585bced692c3b45$var$R(n, n.nextSibling, this, t) : 1 === u.type ? i = new u.ctor(n, u.name, u.strings, this, t) : 6 === u.type && (i = new $0585bced692c3b45$var$Z(n, this, t)), this._$AV.push(i), u = e[++h];
            }
            l !== (null == u ? void 0 : u.index) && (n = $0585bced692c3b45$var$C.nextNode(), l++);
        }
        return $0585bced692c3b45$var$C.currentNode = $0585bced692c3b45$var$r, o;
    }
    v(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class $0585bced692c3b45$var$R {
    constructor(t, i, s, e){
        var o;
        this.type = 2, this._$AH = $0585bced692c3b45$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this._$Cp = null === (o = null == e ? void 0 : e.isConnected) || void 0 === o || o;
    }
    get _$AU() {
        var t, i;
        return null !== (i = null === (t = this._$AM) || void 0 === t ? void 0 : t._$AU) && void 0 !== i ? i : this._$Cp;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === (null == t ? void 0 : t.nodeType) && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $0585bced692c3b45$var$S(this, t, i), $0585bced692c3b45$var$d(t) ? t === $0585bced692c3b45$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $0585bced692c3b45$export$45b790e32b2810ee && this._$AR(), this._$AH = $0585bced692c3b45$export$45b790e32b2810ee) : t !== this._$AH && t !== $0585bced692c3b45$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.g(t) : void 0 !== t.nodeType ? this.$(t) : $0585bced692c3b45$var$v(t) ? this.T(t) : this._(t);
    }
    k(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    $(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.k(t));
    }
    _(t) {
        this._$AH !== $0585bced692c3b45$export$45b790e32b2810ee && $0585bced692c3b45$var$d(this._$AH) ? this._$AA.nextSibling.data = t : this.$($0585bced692c3b45$var$r.createTextNode(t)), this._$AH = t;
    }
    g(t) {
        var i;
        const { values: s, _$litType$: e } = t, o = "number" == typeof e ? this._$AC(t) : (void 0 === e.el && (e.el = $0585bced692c3b45$var$N.createElement($0585bced692c3b45$var$P(e.h, e.h[0]), this.options)), e);
        if ((null === (i = this._$AH) || void 0 === i ? void 0 : i._$AD) === o) this._$AH.v(s);
        else {
            const t = new $0585bced692c3b45$var$M(o, this), i = t.u(this.options);
            t.v(s), this.$(i), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $0585bced692c3b45$var$E.get(t.strings);
        return void 0 === i && $0585bced692c3b45$var$E.set(t.strings, i = new $0585bced692c3b45$var$N(t)), i;
    }
    T(t) {
        $0585bced692c3b45$var$c(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const o of t)e === i.length ? i.push(s = new $0585bced692c3b45$var$R(this.k($0585bced692c3b45$var$u()), this.k($0585bced692c3b45$var$u()), this, this.options)) : s = i[e], s._$AI(o), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, i) {
        var s;
        for(null === (s = this._$AP) || void 0 === s || s.call(this, !1, !0, i); t && t !== this._$AB;){
            const i = t.nextSibling;
            t.remove(), t = i;
        }
    }
    setConnected(t) {
        var i;
        void 0 === this._$AM && (this._$Cp = t, null === (i = this._$AP) || void 0 === i || i.call(this, t));
    }
}
class $0585bced692c3b45$var$k {
    constructor(t, i, s, e, o){
        this.type = 1, this._$AH = $0585bced692c3b45$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = o, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $0585bced692c3b45$export$45b790e32b2810ee;
    }
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t, i = this, s, e) {
        const o = this.strings;
        let n = !1;
        if (void 0 === o) t = $0585bced692c3b45$var$S(this, t, i, 0), n = !$0585bced692c3b45$var$d(t) || t !== this._$AH && t !== $0585bced692c3b45$export$9c068ae9cc5db4e8, n && (this._$AH = t);
        else {
            const e = t;
            let l, h;
            for(t = o[0], l = 0; l < o.length - 1; l++)h = $0585bced692c3b45$var$S(this, e[s + l], i, l), h === $0585bced692c3b45$export$9c068ae9cc5db4e8 && (h = this._$AH[l]), n || (n = !$0585bced692c3b45$var$d(h) || h !== this._$AH[l]), h === $0585bced692c3b45$export$45b790e32b2810ee ? t = $0585bced692c3b45$export$45b790e32b2810ee : t !== $0585bced692c3b45$export$45b790e32b2810ee && (t += (null != h ? h : "") + o[l + 1]), this._$AH[l] = h;
        }
        n && !e && this.j(t);
    }
    j(t) {
        t === $0585bced692c3b45$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, null != t ? t : "");
    }
}
class $0585bced692c3b45$var$H extends $0585bced692c3b45$var$k {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t) {
        this.element[this.name] = t === $0585bced692c3b45$export$45b790e32b2810ee ? void 0 : t;
    }
}
const $0585bced692c3b45$var$I = $0585bced692c3b45$var$s ? $0585bced692c3b45$var$s.emptyScript : "";
class $0585bced692c3b45$var$L extends $0585bced692c3b45$var$k {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t) {
        t && t !== $0585bced692c3b45$export$45b790e32b2810ee ? this.element.setAttribute(this.name, $0585bced692c3b45$var$I) : this.element.removeAttribute(this.name);
    }
}
class $0585bced692c3b45$var$z extends $0585bced692c3b45$var$k {
    constructor(t, i, s, e, o){
        super(t, i, s, e, o), this.type = 5;
    }
    _$AI(t, i = this) {
        var s;
        if ((t = null !== (s = $0585bced692c3b45$var$S(this, t, i, 0)) && void 0 !== s ? s : $0585bced692c3b45$export$45b790e32b2810ee) === $0585bced692c3b45$export$9c068ae9cc5db4e8) return;
        const e = this._$AH, o = t === $0585bced692c3b45$export$45b790e32b2810ee && e !== $0585bced692c3b45$export$45b790e32b2810ee || t.capture !== e.capture || t.once !== e.once || t.passive !== e.passive, n = t !== $0585bced692c3b45$export$45b790e32b2810ee && (e === $0585bced692c3b45$export$45b790e32b2810ee || o);
        o && this.element.removeEventListener(this.name, this, e), n && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        var i, s;
        "function" == typeof this._$AH ? this._$AH.call(null !== (s = null === (i = this.options) || void 0 === i ? void 0 : i.host) && void 0 !== s ? s : this.element, t) : this._$AH.handleEvent(t);
    }
}
class $0585bced692c3b45$var$Z {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $0585bced692c3b45$var$S(this, t);
    }
}
const $0585bced692c3b45$export$8613d1ca9052b22e = {
    O: $0585bced692c3b45$var$o,
    P: $0585bced692c3b45$var$n,
    A: $0585bced692c3b45$var$l,
    C: 1,
    M: $0585bced692c3b45$var$V,
    L: $0585bced692c3b45$var$M,
    R: $0585bced692c3b45$var$v,
    D: $0585bced692c3b45$var$S,
    I: $0585bced692c3b45$var$R,
    V: $0585bced692c3b45$var$k,
    H: $0585bced692c3b45$var$L,
    N: $0585bced692c3b45$var$z,
    U: $0585bced692c3b45$var$H,
    F: $0585bced692c3b45$var$Z
}, $0585bced692c3b45$var$B = $0585bced692c3b45$var$i.litHtmlPolyfillSupport;
null == $0585bced692c3b45$var$B || $0585bced692c3b45$var$B($0585bced692c3b45$var$N, $0585bced692c3b45$var$R), (null !== ($0585bced692c3b45$var$t = $0585bced692c3b45$var$i.litHtmlVersions) && void 0 !== $0585bced692c3b45$var$t ? $0585bced692c3b45$var$t : $0585bced692c3b45$var$i.litHtmlVersions = []).push("2.8.0");
const $0585bced692c3b45$export$b3890eb0ae9dca99 = (t, i, s)=>{
    var e, o;
    const n = null !== (e = null == s ? void 0 : s.renderBefore) && void 0 !== e ? e : i;
    let l = n._$litPart$;
    if (void 0 === l) {
        const t = null !== (o = null == s ? void 0 : s.renderBefore) && void 0 !== o ? o : null;
        n._$litPart$ = l = new $0585bced692c3b45$var$R(i.insertBefore($0585bced692c3b45$var$u(), t), t, void 0, null != s ? s : {});
    }
    return l._$AI(t), l;
};



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $4da6ecdff868c42e$export$9ba3b3f20a85bfa = {
    ATTRIBUTE: 1,
    CHILD: 2,
    PROPERTY: 3,
    BOOLEAN_ATTRIBUTE: 4,
    EVENT: 5,
    ELEMENT: 6
}, $4da6ecdff868c42e$export$99b43ad1ed32e735 = (t)=>(...e)=>({
            _$litDirective$: t,
            values: e
        });
class $4da6ecdff868c42e$export$befdefbdce210f91 {
    constructor(t){}
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AT(t, e, i) {
        this._$Ct = t, this._$AM = e, this._$Ci = i;
    }
    _$AS(t, e) {
        return this.update(t, e);
    }
    update(t, e) {
        return this.render(...e);
    }
}



/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { I: $8916f75be6085108$var$l } = (0, $0585bced692c3b45$export$8613d1ca9052b22e), $8916f75be6085108$export$c3825b437cbdea5c = (o)=>null === o || "object" != typeof o && "function" != typeof o, $8916f75be6085108$export$80c36ae3cab9881d = {
    HTML: 1,
    SVG: 2
}, $8916f75be6085108$export$6b6d145ec2a44ca9 = (o, l)=>void 0 === l ? void 0 !== (null == o ? void 0 : o._$litType$) : (null == o ? void 0 : o._$litType$) === l, $8916f75be6085108$export$6a0e8de894d2fcca = (o)=>{
    var l;
    return null != (null === (l = null == o ? void 0 : o._$litType$) || void 0 === l ? void 0 : l.h);
}, $8916f75be6085108$export$2f448fec17d50a3e = (o)=>void 0 !== (null == o ? void 0 : o._$litDirective$), $8916f75be6085108$export$f28e31de6a6eaf32 = (o)=>null == o ? void 0 : o._$litDirective$, $8916f75be6085108$export$7f431ad0fff82fd9 = (o)=>void 0 === o.strings, $8916f75be6085108$var$r = ()=>document.createComment(""), $8916f75be6085108$export$291b2338ad9b0b30 = (o, i, n)=>{
    var t;
    const v = o._$AA.parentNode, d = void 0 === i ? o._$AB : i._$AA;
    if (void 0 === n) {
        const i = v.insertBefore($8916f75be6085108$var$r(), d), t = v.insertBefore($8916f75be6085108$var$r(), d);
        n = new $8916f75be6085108$var$l(i, t, o, o.options);
    } else {
        const l = n._$AB.nextSibling, i = n._$AM, u = i !== o;
        if (u) {
            let l;
            null === (t = n._$AQ) || void 0 === t || t.call(n, o), n._$AM = o, void 0 !== n._$AP && (l = o._$AU) !== i._$AU && n._$AP(l);
        }
        if (l !== d || u) {
            let o = n._$AA;
            for(; o !== l;){
                const l = o.nextSibling;
                v.insertBefore(o, d), o = l;
            }
        }
    }
    return n;
}, $8916f75be6085108$export$cb8bf9562088e9f4 = (o, l, i = o)=>(o._$AI(l, i), o), $8916f75be6085108$var$s = {}, $8916f75be6085108$export$ea70d9dd5965b1c8 = (o, l = $8916f75be6085108$var$s)=>o._$AH = l, $8916f75be6085108$export$59e9bce518cde500 = (o)=>o._$AH, $8916f75be6085108$export$3133b3144bbba267 = (o)=>{
    var l;
    null === (l = o._$AP) || void 0 === l || l.call(o, !1, !0);
    let i = o._$AA;
    const n = o._$AB.nextSibling;
    for(; i !== n;){
        const o = i.nextSibling;
        i.remove(), i = o;
    }
}, $8916f75be6085108$export$7f600b8138c094dc = (o)=>{
    o._$AR();
};


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $2d06e2ab5b695b60$var$u = (e, s, t)=>{
    const r = new Map;
    for(let l = s; l <= t; l++)r.set(e[l], l);
    return r;
}, $2d06e2ab5b695b60$export$76d90c956114f2c2 = (0, $4da6ecdff868c42e$export$99b43ad1ed32e735)(class extends (0, $4da6ecdff868c42e$export$befdefbdce210f91) {
    constructor(e){
        if (super(e), e.type !== (0, $4da6ecdff868c42e$export$9ba3b3f20a85bfa).CHILD) throw Error("repeat() can only be used in text expressions");
    }
    ct(e, s, t) {
        let r;
        void 0 === t ? t = s : void 0 !== s && (r = s);
        const l = [], o = [];
        let i = 0;
        for (const s of e)l[i] = r ? r(s, i) : i, o[i] = t(s, i), i++;
        return {
            values: o,
            keys: l
        };
    }
    render(e, s, t) {
        return this.ct(e, s, t).values;
    }
    update(s, [t, r, c]) {
        var d;
        const a = (0, $8916f75be6085108$export$59e9bce518cde500)(s), { values: p, keys: v } = this.ct(t, r, c);
        if (!Array.isArray(a)) return this.ut = v, p;
        const h = null !== (d = this.ut) && void 0 !== d ? d : this.ut = [], m = [];
        let y, x, j = 0, k = a.length - 1, w = 0, A = p.length - 1;
        for(; j <= k && w <= A;)if (null === a[j]) j++;
        else if (null === a[k]) k--;
        else if (h[j] === v[w]) m[w] = (0, $8916f75be6085108$export$cb8bf9562088e9f4)(a[j], p[w]), j++, w++;
        else if (h[k] === v[A]) m[A] = (0, $8916f75be6085108$export$cb8bf9562088e9f4)(a[k], p[A]), k--, A--;
        else if (h[j] === v[A]) m[A] = (0, $8916f75be6085108$export$cb8bf9562088e9f4)(a[j], p[A]), (0, $8916f75be6085108$export$291b2338ad9b0b30)(s, m[A + 1], a[j]), j++, A--;
        else if (h[k] === v[w]) m[w] = (0, $8916f75be6085108$export$cb8bf9562088e9f4)(a[k], p[w]), (0, $8916f75be6085108$export$291b2338ad9b0b30)(s, a[j], a[k]), k--, w++;
        else if (void 0 === y && (y = $2d06e2ab5b695b60$var$u(v, w, A), x = $2d06e2ab5b695b60$var$u(h, j, k)), y.has(h[j])) {
            if (y.has(h[k])) {
                const e = x.get(v[w]), t = void 0 !== e ? a[e] : null;
                if (null === t) {
                    const e = (0, $8916f75be6085108$export$291b2338ad9b0b30)(s, a[j]);
                    (0, $8916f75be6085108$export$cb8bf9562088e9f4)(e, p[w]), m[w] = e;
                } else m[w] = (0, $8916f75be6085108$export$cb8bf9562088e9f4)(t, p[w]), (0, $8916f75be6085108$export$291b2338ad9b0b30)(s, a[j], t), a[e] = null;
                w++;
            } else (0, $8916f75be6085108$export$3133b3144bbba267)(a[k]), k--;
        } else (0, $8916f75be6085108$export$3133b3144bbba267)(a[j]), j++;
        for(; w <= A;){
            const e = (0, $8916f75be6085108$export$291b2338ad9b0b30)(s, m[A + 1]);
            (0, $8916f75be6085108$export$cb8bf9562088e9f4)(e, p[w]), m[w++] = e;
        }
        for(; j <= k;){
            const e = a[j++];
            null !== e && (0, $8916f75be6085108$export$3133b3144bbba267)(e);
        }
        return this.ut = v, (0, $8916f75be6085108$export$ea70d9dd5965b1c8)(s, m), $0585bced692c3b45$export$9c068ae9cc5db4e8;
    }
});






/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $aa51d98594d61009$var$s = (i, t)=>{
    var e, o;
    const r = i._$AN;
    if (void 0 === r) return !1;
    for (const i of r)null === (o = (e = i)._$AO) || void 0 === o || o.call(e, t, !1), $aa51d98594d61009$var$s(i, t);
    return !0;
}, $aa51d98594d61009$var$o = (i)=>{
    let t, e;
    do {
        if (void 0 === (t = i._$AM)) break;
        e = t._$AN, e.delete(i), i = t;
    }while (0 === (null == e ? void 0 : e.size));
}, $aa51d98594d61009$var$r = (i)=>{
    for(let t; t = i._$AM; i = t){
        let e = t._$AN;
        if (void 0 === e) t._$AN = e = new Set;
        else if (e.has(i)) break;
        e.add(i), $aa51d98594d61009$var$l(t);
    }
};
function $aa51d98594d61009$var$n(i) {
    void 0 !== this._$AN ? ($aa51d98594d61009$var$o(this), this._$AM = i, $aa51d98594d61009$var$r(this)) : this._$AM = i;
}
function $aa51d98594d61009$var$h(i, t = !1, e = 0) {
    const r = this._$AH, n = this._$AN;
    if (void 0 !== n && 0 !== n.size) {
        if (t) {
            if (Array.isArray(r)) for(let i = e; i < r.length; i++)$aa51d98594d61009$var$s(r[i], !1), $aa51d98594d61009$var$o(r[i]);
            else null != r && ($aa51d98594d61009$var$s(r, !1), $aa51d98594d61009$var$o(r));
        } else $aa51d98594d61009$var$s(this, i);
    }
}
const $aa51d98594d61009$var$l = (i)=>{
    var t, s, o, r;
    i.type == (0, $4da6ecdff868c42e$export$9ba3b3f20a85bfa).CHILD && (null !== (t = (o = i)._$AP) && void 0 !== t || (o._$AP = $aa51d98594d61009$var$h), null !== (s = (r = i)._$AQ) && void 0 !== s || (r._$AQ = $aa51d98594d61009$var$n));
};
class $aa51d98594d61009$export$7d025501802325e extends (0, $4da6ecdff868c42e$export$befdefbdce210f91) {
    constructor(){
        super(...arguments), this._$AN = void 0;
    }
    _$AT(i, t, e) {
        super._$AT(i, t, e), $aa51d98594d61009$var$r(this), this.isConnected = i._$AU;
    }
    _$AO(i, t = !0) {
        var e, r;
        i !== this.isConnected && (this.isConnected = i, i ? null === (e = this.reconnected) || void 0 === e || e.call(this) : null === (r = this.disconnected) || void 0 === r || r.call(this)), t && ($aa51d98594d61009$var$s(this, i), $aa51d98594d61009$var$o(this));
    }
    setValue(t) {
        if ((0, $8916f75be6085108$export$7f431ad0fff82fd9)(this._$Ct)) this._$Ct._$AI(t, this);
        else {
            const i = [
                ...this._$Ct._$AH
            ];
            i[this._$Ci] = t, this._$Ct._$AI(i, this, 0);
        }
    }
    disconnected() {}
    reconnected() {}
}


/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $7a66d9d32f17f475$export$74673a32c6041f3e = async (t, s)=>{
    for await (const i of t)if (!1 === await s(i)) return;
};
class $7a66d9d32f17f475$export$71341b9b69479007 {
    constructor(t){
        this.G = t;
    }
    disconnect() {
        this.G = void 0;
    }
    reconnect(t) {
        this.G = t;
    }
    deref() {
        return this.G;
    }
}
class $7a66d9d32f17f475$export$193ea5a420bb5c41 {
    constructor(){
        this.Y = void 0, this.Z = void 0;
    }
    get() {
        return this.Y;
    }
    pause() {
        var t;
        null !== (t = this.Y) && void 0 !== t || (this.Y = new Promise((t)=>this.Z = t));
    }
    resume() {
        var t;
        null === (t = this.Z) || void 0 === t || t.call(this), this.Y = this.Z = void 0;
    }
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ class $9a7b48e7039d5564$export$39a433aa22cdf479 extends (0, $aa51d98594d61009$export$7d025501802325e) {
    constructor(){
        super(...arguments), this._$Cq = new (0, $7a66d9d32f17f475$export$71341b9b69479007)(this), this._$CK = new (0, $7a66d9d32f17f475$export$193ea5a420bb5c41);
    }
    render(i, s) {
        return 0, $0585bced692c3b45$export$9c068ae9cc5db4e8;
    }
    update(i, [s, r]) {
        if (this.isConnected || this.disconnected(), s === this._$CX) return;
        this._$CX = s;
        let n = 0;
        const { _$Cq: o, _$CK: h } = this;
        return (0, $7a66d9d32f17f475$export$74673a32c6041f3e)(s, async (t)=>{
            for(; h.get();)await h.get();
            const i = o.deref();
            if (void 0 !== i) {
                if (i._$CX !== s) return !1;
                void 0 !== r && (t = r(t, n)), i.commitValue(t, n), n++;
            }
            return !0;
        }), $0585bced692c3b45$export$9c068ae9cc5db4e8;
    }
    commitValue(t, i) {
        this.setValue(t);
    }
    disconnected() {
        this._$Cq.disconnect(), this._$CK.pause();
    }
    reconnected() {
        this._$Cq.reconnect(this), this._$CK.resume();
    }
}
const $9a7b48e7039d5564$export$662eef59ff6bd56a = (0, $4da6ecdff868c42e$export$99b43ad1ed32e735)($9a7b48e7039d5564$export$39a433aa22cdf479);



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $82e12a832c7dc237$export$eaa89ade56b7c0c1 = (0, $4da6ecdff868c42e$export$99b43ad1ed32e735)(class extends (0, $9a7b48e7039d5564$export$39a433aa22cdf479) {
    constructor(r){
        if (super(r), r.type !== (0, $4da6ecdff868c42e$export$9ba3b3f20a85bfa).CHILD) throw Error("asyncAppend can only be used in child expressions");
    }
    update(r, e) {
        return this._$CJ = r, super.update(r, e);
    }
    commitValue(r, e) {
        0 === e && (0, $8916f75be6085108$export$7f600b8138c094dc)(this._$CJ);
        const s = (0, $8916f75be6085108$export$291b2338ad9b0b30)(this._$CJ);
        (0, $8916f75be6085108$export$cb8bf9562088e9f4)(s, r);
    }
});






/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $77f5167d06bc2fde$var$d = (t)=>(0, $8916f75be6085108$export$6a0e8de894d2fcca)(t) ? t._$litType$.h : t.strings, $77f5167d06bc2fde$export$69a3209f1a06c04d = (0, $4da6ecdff868c42e$export$99b43ad1ed32e735)(class extends (0, $4da6ecdff868c42e$export$befdefbdce210f91) {
    constructor(t){
        super(t), this.tt = new WeakMap;
    }
    render(t) {
        return [
            t
        ];
    }
    update(s, [e]) {
        const u = (0, $8916f75be6085108$export$6b6d145ec2a44ca9)(this.et) ? $77f5167d06bc2fde$var$d(this.et) : null, h = (0, $8916f75be6085108$export$6b6d145ec2a44ca9)(e) ? $77f5167d06bc2fde$var$d(e) : null;
        if (null !== u && (null === h || u !== h)) {
            const e = (0, $8916f75be6085108$export$59e9bce518cde500)(s).pop();
            let o = this.tt.get(u);
            if (void 0 === o) {
                const s = document.createDocumentFragment();
                o = (0, $0585bced692c3b45$export$b3890eb0ae9dca99)((0, $0585bced692c3b45$export$45b790e32b2810ee), s), o.setConnected(!1), this.tt.set(u, o);
            }
            (0, $8916f75be6085108$export$ea70d9dd5965b1c8)(o, [
                e
            ]), (0, $8916f75be6085108$export$291b2338ad9b0b30)(o, void 0, e);
        }
        if (null !== h) {
            if (null === u || u !== h) {
                const t = this.tt.get(h);
                if (void 0 !== t) {
                    const i = (0, $8916f75be6085108$export$59e9bce518cde500)(t).pop();
                    (0, $8916f75be6085108$export$7f600b8138c094dc)(s), (0, $8916f75be6085108$export$291b2338ad9b0b30)(s, void 0, i), (0, $8916f75be6085108$export$ea70d9dd5965b1c8)(s, [
                        i
                    ]);
                }
            }
            this.et = e;
        } else this.et = void 0;
        return this.render(e);
    }
});




/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $e4437dd0216a4379$export$56cc687933817664 = (0, $4da6ecdff868c42e$export$99b43ad1ed32e735)(class extends (0, $4da6ecdff868c42e$export$befdefbdce210f91) {
    constructor(t){
        var i;
        if (super(t), t.type !== (0, $4da6ecdff868c42e$export$9ba3b3f20a85bfa).ATTRIBUTE || "class" !== t.name || (null === (i = t.strings) || void 0 === i ? void 0 : i.length) > 2) throw Error("`classMap()` can only be used in the `class` attribute and must be the only part in the attribute.");
    }
    render(t) {
        return " " + Object.keys(t).filter((i)=>t[i]).join(" ") + " ";
    }
    update(i, [s]) {
        var r, o;
        if (void 0 === this.it) {
            this.it = new Set, void 0 !== i.strings && (this.nt = new Set(i.strings.join(" ").split(/\s/).filter((t)=>"" !== t)));
            for(const t in s)s[t] && !(null === (r = this.nt) || void 0 === r ? void 0 : r.has(t)) && this.it.add(t);
            return this.render(s);
        }
        const e = i.element.classList;
        this.it.forEach((t)=>{
            t in s || (e.remove(t), this.it.delete(t));
        });
        for(const t in s){
            const i = !!s[t];
            i === this.it.has(t) || (null === (o = this.nt) || void 0 === o ? void 0 : o.has(t)) || (i ? (e.add(t), this.it.add(t)) : (e.remove(t), this.it.delete(t)));
        }
        return 0, $0585bced692c3b45$export$9c068ae9cc5db4e8;
    }
});




/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $0100bfbf2c1b33f3$var$e = {}, $0100bfbf2c1b33f3$export$864d727b48066337 = (0, $4da6ecdff868c42e$export$99b43ad1ed32e735)(class extends (0, $4da6ecdff868c42e$export$befdefbdce210f91) {
    constructor(){
        super(...arguments), this.st = $0100bfbf2c1b33f3$var$e;
    }
    render(r, t) {
        return t();
    }
    update(t, [s, e]) {
        if (Array.isArray(s)) {
            if (Array.isArray(this.st) && this.st.length === s.length && s.every((r, t)=>r === this.st[t])) return 0, $0585bced692c3b45$export$9c068ae9cc5db4e8;
        } else if (this.st === s) return 0, $0585bced692c3b45$export$9c068ae9cc5db4e8;
        return this.st = Array.isArray(s) ? Array.from(s) : s, this.render(s, e);
    }
});





/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $2ed4c26e5fc1311e$export$28cf49ad70f82d12 = (0, $4da6ecdff868c42e$export$99b43ad1ed32e735)(class extends (0, $4da6ecdff868c42e$export$befdefbdce210f91) {
    constructor(r){
        if (super(r), r.type !== (0, $4da6ecdff868c42e$export$9ba3b3f20a85bfa).PROPERTY && r.type !== (0, $4da6ecdff868c42e$export$9ba3b3f20a85bfa).ATTRIBUTE && r.type !== (0, $4da6ecdff868c42e$export$9ba3b3f20a85bfa).BOOLEAN_ATTRIBUTE) throw Error("The `live` directive is not allowed on child or event bindings");
        if (!(0, $8916f75be6085108$export$7f431ad0fff82fd9)(r)) throw Error("`live` bindings can only contain a single expression");
    }
    render(r) {
        return r;
    }
    update(i, [t]) {
        if (t === (0, $0585bced692c3b45$export$9c068ae9cc5db4e8) || t === (0, $0585bced692c3b45$export$45b790e32b2810ee)) return t;
        const o = i.element, l = i.name;
        if (i.type === (0, $4da6ecdff868c42e$export$9ba3b3f20a85bfa).PROPERTY) {
            if (t === o[l]) return 0, $0585bced692c3b45$export$9c068ae9cc5db4e8;
        } else if (i.type === (0, $4da6ecdff868c42e$export$9ba3b3f20a85bfa).BOOLEAN_ATTRIBUTE) {
            if (!!t === o.hasAttribute(l)) return 0, $0585bced692c3b45$export$9c068ae9cc5db4e8;
        } else if (i.type === (0, $4da6ecdff868c42e$export$9ba3b3f20a85bfa).ATTRIBUTE && o.getAttribute(l) === t + "") return 0, $0585bced692c3b45$export$9c068ae9cc5db4e8;
        return (0, $8916f75be6085108$export$ea70d9dd5965b1c8)(i), t;
    }
});





/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $65d76be7707749f6$export$7d1e3a5e95ceca43 = ()=>new $65d76be7707749f6$var$o;
class $65d76be7707749f6$var$o {
}
const $65d76be7707749f6$var$h = new WeakMap, $65d76be7707749f6$export$eff4d24c3ff7876e = (0, $4da6ecdff868c42e$export$99b43ad1ed32e735)(class extends (0, $aa51d98594d61009$export$7d025501802325e) {
    render(t) {
        return 0, $0585bced692c3b45$export$45b790e32b2810ee;
    }
    update(t, [s]) {
        var e;
        const o = s !== this.G;
        return o && void 0 !== this.G && this.ot(void 0), (o || this.rt !== this.lt) && (this.G = s, this.dt = null === (e = t.options) || void 0 === e ? void 0 : e.host, this.ot(this.lt = t.element)), $0585bced692c3b45$export$45b790e32b2810ee;
    }
    ot(i) {
        var t;
        if ("function" == typeof this.G) {
            const s = null !== (t = this.dt) && void 0 !== t ? t : globalThis;
            let e = $65d76be7707749f6$var$h.get(s);
            void 0 === e && (e = new WeakMap, $65d76be7707749f6$var$h.set(s, e)), void 0 !== e.get(this.G) && this.G.call(this.dt, void 0), e.set(this.G, i), void 0 !== i && this.G.call(this.dt, i);
        } else this.G.value = i;
    }
    get rt() {
        var i, t, s;
        return "function" == typeof this.G ? null === (t = $65d76be7707749f6$var$h.get(null !== (i = this.dt) && void 0 !== i ? i : globalThis)) || void 0 === t ? void 0 : t.get(this.G) : null === (s = this.G) || void 0 === s ? void 0 : s.value;
    }
    disconnected() {
        this.rt === this.lt && this.ot(void 0);
    }
    reconnected() {
        this.ot(this.lt);
    }
});




/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $22f699b0009eb85b$var$i = "important", $22f699b0009eb85b$var$n = " !" + $22f699b0009eb85b$var$i, $22f699b0009eb85b$export$1e5b4ce2fa884e6a = (0, $4da6ecdff868c42e$export$99b43ad1ed32e735)(class extends (0, $4da6ecdff868c42e$export$befdefbdce210f91) {
    constructor(t){
        var e;
        if (super(t), t.type !== (0, $4da6ecdff868c42e$export$9ba3b3f20a85bfa).ATTRIBUTE || "style" !== t.name || (null === (e = t.strings) || void 0 === e ? void 0 : e.length) > 2) throw Error("The `styleMap` directive must be used in the `style` attribute and must be the only part in the attribute.");
    }
    render(t) {
        return Object.keys(t).reduce((e, r)=>{
            const s = t[r];
            return null == s ? e : e + `${r = r.includes("-") ? r : r.replace(/(?:^(webkit|moz|ms|o)|)(?=[A-Z])/g, "-$&").toLowerCase()}:${s};`;
        }, "");
    }
    update(e, [r]) {
        const { style: s } = e.element;
        if (void 0 === this.ht) {
            this.ht = new Set;
            for(const t in r)this.ht.add(t);
            return this.render(r);
        }
        this.ht.forEach((t)=>{
            null == r[t] && (this.ht.delete(t), t.includes("-") ? s.removeProperty(t) : s[t] = "");
        });
        for(const t in r){
            const e = r[t];
            if (null != e) {
                this.ht.add(t);
                const r = "string" == typeof e && e.endsWith($22f699b0009eb85b$var$n);
                t.includes("-") || r ? s.setProperty(t, r ? e.slice(0, -11) : e, r ? $22f699b0009eb85b$var$i : "") : s[t] = e;
            }
        }
        return 0, $0585bced692c3b45$export$9c068ae9cc5db4e8;
    }
});




/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $9a609a3f11152775$export$e446d0492332fcd4 = (0, $4da6ecdff868c42e$export$99b43ad1ed32e735)(class extends (0, $4da6ecdff868c42e$export$befdefbdce210f91) {
    constructor(t){
        if (super(t), t.type !== (0, $4da6ecdff868c42e$export$9ba3b3f20a85bfa).CHILD) throw Error("templateContent can only be used in child bindings");
    }
    render(r) {
        return this.vt === r ? (0, $0585bced692c3b45$export$9c068ae9cc5db4e8) : (this.vt = r, document.importNode(r.content, !0));
    }
});




/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ class $0a9d83bb2173ec99$export$3bebd1f0e3943985 extends (0, $4da6ecdff868c42e$export$befdefbdce210f91) {
    constructor(i){
        if (super(i), this.et = (0, $0585bced692c3b45$export$45b790e32b2810ee), i.type !== (0, $4da6ecdff868c42e$export$9ba3b3f20a85bfa).CHILD) throw Error(this.constructor.directiveName + "() can only be used in child bindings");
    }
    render(r) {
        if (r === (0, $0585bced692c3b45$export$45b790e32b2810ee) || null == r) return this.ft = void 0, this.et = r;
        if (r === (0, $0585bced692c3b45$export$9c068ae9cc5db4e8)) return r;
        if ("string" != typeof r) throw Error(this.constructor.directiveName + "() called with a non-string value");
        if (r === this.et) return this.ft;
        this.et = r;
        const s = [
            r
        ];
        return s.raw = s, this.ft = {
            _$litType$: this.constructor.resultType,
            strings: s,
            values: []
        };
    }
}
$0a9d83bb2173ec99$export$3bebd1f0e3943985.directiveName = "unsafeHTML", $0a9d83bb2173ec99$export$3bebd1f0e3943985.resultType = 1;
const $0a9d83bb2173ec99$export$b6e69390c23686fb = (0, $4da6ecdff868c42e$export$99b43ad1ed32e735)($0a9d83bb2173ec99$export$3bebd1f0e3943985);




/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ class $378ddd6808e465bc$var$t extends (0, $0a9d83bb2173ec99$export$3bebd1f0e3943985) {
}
$378ddd6808e465bc$var$t.directiveName = "unsafeSVG", $378ddd6808e465bc$var$t.resultType = 2;
const $378ddd6808e465bc$export$1cb98903879b8bf5 = (0, $4da6ecdff868c42e$export$99b43ad1ed32e735)($378ddd6808e465bc$var$t);







/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $04babc6848c3c9b3$var$n = (t)=>!(0, $8916f75be6085108$export$c3825b437cbdea5c)(t) && "function" == typeof t.then, $04babc6848c3c9b3$var$h = 1073741823;
class $04babc6848c3c9b3$export$51c6edf8ee19b71a extends (0, $aa51d98594d61009$export$7d025501802325e) {
    constructor(){
        super(...arguments), this._$C_t = $04babc6848c3c9b3$var$h, this._$Cwt = [], this._$Cq = new (0, $7a66d9d32f17f475$export$71341b9b69479007)(this), this._$CK = new (0, $7a66d9d32f17f475$export$193ea5a420bb5c41);
    }
    render(...s) {
        var i;
        return null !== (i = s.find((t)=>!$04babc6848c3c9b3$var$n(t))) && void 0 !== i ? i : (0, $0585bced692c3b45$export$9c068ae9cc5db4e8);
    }
    update(s, i) {
        const r = this._$Cwt;
        let e = r.length;
        this._$Cwt = i;
        const o = this._$Cq, c = this._$CK;
        this.isConnected || this.disconnected();
        for(let t = 0; t < i.length && !(t > this._$C_t); t++){
            const s = i[t];
            if (!$04babc6848c3c9b3$var$n(s)) return this._$C_t = t, s;
            t < e && s === r[t] || (this._$C_t = $04babc6848c3c9b3$var$h, e = 0, Promise.resolve(s).then(async (t)=>{
                for(; c.get();)await c.get();
                const i = o.deref();
                if (void 0 !== i) {
                    const r = i._$Cwt.indexOf(s);
                    r > -1 && r < i._$C_t && (i._$C_t = r, i.setValue(t));
                }
            }));
        }
        return 0, $0585bced692c3b45$export$9c068ae9cc5db4e8;
    }
    disconnected() {
        this._$Cq.disconnect(), this._$CK.pause();
    }
    reconnected() {
        this._$Cq.reconnect(this), this._$CK.resume();
    }
}
const $04babc6848c3c9b3$export$a40009bd2c363351 = (0, $4da6ecdff868c42e$export$99b43ad1ed32e735)($04babc6848c3c9b3$export$51c6edf8ee19b71a);


/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $7b7b9a37160c97db$export$7877a478dd30fd3d = (o, r, n)=>{
    for (const n of r)if (n[0] === o) return (0, n[1])();
    return null == n ? void 0 : n();
};



/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $49f9812d6d4b3bb6$export$f68dd208b5df064d = (l)=>null != l ? l : (0, $0585bced692c3b45$export$45b790e32b2810ee);


/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function* $0d7955f0662edf92$export$f7e2c8231c57a8bd(o, t) {
    const f = "function" == typeof t;
    if (void 0 !== o) {
        let i = -1;
        for (const n of o)i > -1 && (yield f ? t(i) : t), i++, yield n;
    }
}





/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $ef64bd03c02e190d$export$8dbf9c790527241e = (0, $4da6ecdff868c42e$export$99b43ad1ed32e735)(class extends (0, $4da6ecdff868c42e$export$befdefbdce210f91) {
    constructor(){
        super(...arguments), this.key = (0, $0585bced692c3b45$export$45b790e32b2810ee);
    }
    render(r, t) {
        return this.key = r, t;
    }
    update(r, [t, e]) {
        return t !== this.key && ((0, $8916f75be6085108$export$ea70d9dd5965b1c8)(r), this.key = t), e;
    }
});


/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function* $efb58c27b85b03fa$export$871de8747c9eaa88(o, f) {
    if (void 0 !== o) {
        let i = 0;
        for (const t of o)yield f(t, i++);
    }
}


/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function* $b0f47510656516d3$export$d02631cccf789723(o, l, n = 1) {
    const t = void 0 === l ? 0 : o;
    null != l || (l = o);
    for(let o = t; n > 0 ? o < l : l < o; o += n)yield o;
}


/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $d2deeaf9cd169c53$export$a55877ca9db47377(n, o, r) {
    return n ? o() : null == r ? void 0 : r();
}




"use strict";
/**
 * Eventifies an object (built with inspiration from smokesignals)
 * @param {object} obj the object to be eventified
 * @returns the object
 */ let $8e5676bd73916c78$export$52d98889efa7d412 = (obj)=>{
    // Previously eventified?
    if (obj.on && obj.emit) return obj;
    obj._events_handlers = Object.create(null);
    obj.clearEvents = $8e5676bd73916c78$var$clearEvents;
    obj.emitOnce = $8e5676bd73916c78$var$emitOnce;
    obj.emitAsync = $8e5676bd73916c78$var$emitAsync;
    obj.emit = $8e5676bd73916c78$var$emit;
    obj.once = $8e5676bd73916c78$var$once;
    obj.off = $8e5676bd73916c78$var$off;
    obj.deEventify = $8e5676bd73916c78$var$deEventify;
    /**
     * Adds a listener for an event
     * @param {string} eventName the name of the event
     * @param {*} handler
     * @returns {object} the object
     */ obj.on = function(eventName, handler) {
        if (!handler) return obj;
        let handlerList = obj._events_handlers[eventName];
        if (!handlerList) handlerList = obj._events_handlers[eventName] = [];
        handlerList.push(handler);
        return {
            unsubscribe: ()=>{
                obj.off?.(eventName, handler);
                return obj;
            },
            eventName: eventName,
            on: obj.on.bind(obj)
        };
    };
    return obj;
};
/**
 * Adds a listener for an event where the callbackhandler is only called once
 * @param {string} eventName the name of the event
 * @param {*} handler
 * @returns {object} the object
 */ function $8e5676bd73916c78$var$once(eventName, handler) {
    let obj = this;
    let subscription = obj.on(eventName, (eventData)=>{
        subscription.unsubscribe();
        handler.call(obj, eventData);
        subscription = null;
        handler = null;
    });
    return subscription;
}
/**
 * Removes a listener for an event
 * @param {string} eventName the name of the event
 * @param {function} handler the callback function to remove
 * @returns {object} the object
 */ function $8e5676bd73916c78$var$off(eventName, handler) {
    let obj = this;
    let handlerList = obj._events_handlers[eventName];
    if (!(handlerList && handler)) return obj;
    // Remove all added events for this handler
    let index = handlerList.length;
    while(--index >= 0)if (handlerList[index] === handler) handlerList.splice(index, 1);
    return obj;
}
/**
 * Emits an event only once
 * @param {string} eventName the name of the event
 * @param {*} eventData
 * @returns {object} the object
 */ function $8e5676bd73916c78$var$emitOnce(eventName, eventData) {
    let obj = this;
    let handlerList = obj._events_handlers[eventName];
    if (!handlerList) handlerList = obj._events_handlers[eventName] = [];
    $8e5676bd73916c78$var$emit.call(obj, eventName, eventData);
    handlerList._events_oneTimeEventHasFired = true;
    return obj;
}
/**
 * Emits an event asynchrounosly
 * @param {string} eventName the name of the event
 * @param {*} eventData
 * @returns {object} the object
 */ function $8e5676bd73916c78$var$emitAsync(eventName, eventData) {
    let obj = this;
    setTimeout(()=>{
        obj.emit(eventName, eventData);
    }, 0);
    return obj;
}
/**
 * Emits an event
 * @param {string} eventName the name of the event
 * @param {*} eventData
 * @returns {object} the object
 */ function $8e5676bd73916c78$var$emit(eventName, eventData) {
    let obj = this;
    let handlerList = obj._events_handlers[eventName];
    if (!handlerList?.length) return obj;
    if (handlerList._events_oneTimeEventHasFired) return obj;
    let data = typeof eventData === "function" ? eventData() : eventData;
    // Copy the array to make sure code inside events that might unregister etc.
    // does not prevent all the current attached handlers from beeing called.
    handlerList = handlerList.slice();
    for(let i = 0, length = handlerList.length; i < length; i++)handlerList[i]?.call(obj, data);
    return obj;
}
/**
 * Removes every trace of events on the object
 * @returns {object} the object
 */ function $8e5676bd73916c78$var$deEventify() {
    let obj = this;
    obj.clearEvents?.();
    obj.on = $8e5676bd73916c78$var$noop;
    obj.set = $8e5676bd73916c78$var$noop;
    obj.get = $8e5676bd73916c78$var$noop;
    obj.off = $8e5676bd73916c78$var$noop;
    obj.once = $8e5676bd73916c78$var$noop;
    obj.emit = $8e5676bd73916c78$var$noop;
    obj.emitAsync = $8e5676bd73916c78$var$noop;
    obj.emitOnce = $8e5676bd73916c78$var$noop;
    obj.clearEvents = $8e5676bd73916c78$var$noop;
    obj._events_handlers = null;
    return obj;
}
/**
 *
 * @returns {object} the object
 */ function $8e5676bd73916c78$var$noop() {
    return this;
}
/**
 *
 * @returns {object} the object
 */ function $8e5676bd73916c78$var$clearEvents() {
    let obj = this;
    obj._events_handlers && Object.keys(obj._events_handlers).forEach((key)=>{
        if (obj._events_handlers[key]) {
            obj._events_handlers[key].length = 0;
            obj._events_handlers[key] = null;
        }
    });
    obj._events_handlers = Object.create(null);
    return obj;
}


function $c9361041b5bd802c$var$i() {
    throw new Error("Cycle detected");
}
var $c9361041b5bd802c$var$t = Symbol.for("preact-signals");
function $c9361041b5bd802c$var$r() {
    if (!($c9361041b5bd802c$var$v > 1)) {
        var i, t = !1;
        while(void 0 !== $c9361041b5bd802c$var$f){
            var r = $c9361041b5bd802c$var$f;
            $c9361041b5bd802c$var$f = void 0;
            $c9361041b5bd802c$var$e++;
            while(void 0 !== r){
                var n = r.o;
                r.o = void 0;
                r.f &= -3;
                if (!(8 & r.f) && $c9361041b5bd802c$var$l(r)) try {
                    r.c();
                } catch (r) {
                    if (!t) {
                        i = r;
                        t = !0;
                    }
                }
                r = n;
            }
        }
        $c9361041b5bd802c$var$e = 0;
        $c9361041b5bd802c$var$v--;
        if (t) throw i;
    } else $c9361041b5bd802c$var$v--;
}
function $c9361041b5bd802c$export$712ea50be43a7858(i) {
    if ($c9361041b5bd802c$var$v > 0) return i();
    $c9361041b5bd802c$var$v++;
    try {
        return i();
    } finally{
        $c9361041b5bd802c$var$r();
    }
}
var $c9361041b5bd802c$var$o = void 0, $c9361041b5bd802c$var$h = 0;
function $c9361041b5bd802c$export$8c437e4d572e2f99(i) {
    if ($c9361041b5bd802c$var$h > 0) return i();
    var t = $c9361041b5bd802c$var$o;
    $c9361041b5bd802c$var$o = void 0;
    $c9361041b5bd802c$var$h++;
    try {
        return i();
    } finally{
        $c9361041b5bd802c$var$h--;
        $c9361041b5bd802c$var$o = t;
    }
}
var $c9361041b5bd802c$var$f = void 0, $c9361041b5bd802c$var$v = 0, $c9361041b5bd802c$var$e = 0, $c9361041b5bd802c$var$u = 0;
function $c9361041b5bd802c$var$c(i) {
    if (void 0 !== $c9361041b5bd802c$var$o) {
        var t = i.n;
        if (void 0 === t || t.t !== $c9361041b5bd802c$var$o) {
            t = {
                i: 0,
                S: i,
                p: $c9361041b5bd802c$var$o.s,
                n: void 0,
                t: $c9361041b5bd802c$var$o,
                e: void 0,
                x: void 0,
                r: t
            };
            if (void 0 !== $c9361041b5bd802c$var$o.s) $c9361041b5bd802c$var$o.s.n = t;
            $c9361041b5bd802c$var$o.s = t;
            i.n = t;
            if (32 & $c9361041b5bd802c$var$o.f) i.S(t);
            return t;
        } else if (-1 === t.i) {
            t.i = 0;
            if (void 0 !== t.n) {
                t.n.p = t.p;
                if (void 0 !== t.p) t.p.n = t.n;
                t.p = $c9361041b5bd802c$var$o.s;
                t.n = void 0;
                $c9361041b5bd802c$var$o.s.n = t;
                $c9361041b5bd802c$var$o.s = t;
            }
            return t;
        }
    }
}
function $c9361041b5bd802c$export$8210dfe1863c478(i) {
    this.v = i;
    this.i = 0;
    this.n = void 0;
    this.t = void 0;
}
$c9361041b5bd802c$export$8210dfe1863c478.prototype.brand = $c9361041b5bd802c$var$t;
$c9361041b5bd802c$export$8210dfe1863c478.prototype.h = function() {
    return !0;
};
$c9361041b5bd802c$export$8210dfe1863c478.prototype.S = function(i) {
    if (this.t !== i && void 0 === i.e) {
        i.x = this.t;
        if (void 0 !== this.t) this.t.e = i;
        this.t = i;
    }
};
$c9361041b5bd802c$export$8210dfe1863c478.prototype.U = function(i) {
    if (void 0 !== this.t) {
        var t = i.e, r = i.x;
        if (void 0 !== t) {
            t.x = r;
            i.e = void 0;
        }
        if (void 0 !== r) {
            r.e = t;
            i.x = void 0;
        }
        if (i === this.t) this.t = r;
    }
};
$c9361041b5bd802c$export$8210dfe1863c478.prototype.subscribe = function(i) {
    var t = this;
    return $c9361041b5bd802c$export$dc573d8a6576cdb3(function() {
        var r = t.value, n = 32 & this.f;
        this.f &= -33;
        try {
            i(r);
        } finally{
            this.f |= n;
        }
    });
};
$c9361041b5bd802c$export$8210dfe1863c478.prototype.valueOf = function() {
    return this.value;
};
$c9361041b5bd802c$export$8210dfe1863c478.prototype.toString = function() {
    return this.value + "";
};
$c9361041b5bd802c$export$8210dfe1863c478.prototype.toJSON = function() {
    return this.value;
};
$c9361041b5bd802c$export$8210dfe1863c478.prototype.peek = function() {
    return this.v;
};
Object.defineProperty($c9361041b5bd802c$export$8210dfe1863c478.prototype, "value", {
    get: function() {
        var i = $c9361041b5bd802c$var$c(this);
        if (void 0 !== i) i.i = this.i;
        return this.v;
    },
    set: function(t) {
        if ($c9361041b5bd802c$var$o instanceof $c9361041b5bd802c$var$_) !function() {
            throw new Error("Computed cannot have side-effects");
        }();
        if (t !== this.v) {
            if ($c9361041b5bd802c$var$e > 100) $c9361041b5bd802c$var$i();
            this.v = t;
            this.i++;
            $c9361041b5bd802c$var$u++;
            $c9361041b5bd802c$var$v++;
            try {
                for(var n = this.t; void 0 !== n; n = n.x)n.t.N();
            } finally{
                $c9361041b5bd802c$var$r();
            }
        }
    }
});
function $c9361041b5bd802c$export$e2ef10f86a8d60e8(i) {
    return new $c9361041b5bd802c$export$8210dfe1863c478(i);
}
function $c9361041b5bd802c$var$l(i) {
    for(var t = i.s; void 0 !== t; t = t.n)if (t.S.i !== t.i || !t.S.h() || t.S.i !== t.i) return !0;
    return !1;
}
function $c9361041b5bd802c$var$y(i) {
    for(var t = i.s; void 0 !== t; t = t.n){
        var r = t.S.n;
        if (void 0 !== r) t.r = r;
        t.S.n = t;
        t.i = -1;
        if (void 0 === t.n) {
            i.s = t;
            break;
        }
    }
}
function $c9361041b5bd802c$var$w(i) {
    var t = i.s, r = void 0;
    while(void 0 !== t){
        var n = t.p;
        if (-1 === t.i) {
            t.S.U(t);
            if (void 0 !== n) n.n = t.n;
            if (void 0 !== t.n) t.n.p = n;
        } else r = t;
        t.S.n = t.r;
        if (void 0 !== t.r) t.r = void 0;
        t = n;
    }
    i.s = r;
}
function $c9361041b5bd802c$var$_(i) {
    $c9361041b5bd802c$export$8210dfe1863c478.call(this, void 0);
    this.x = i;
    this.s = void 0;
    this.g = $c9361041b5bd802c$var$u - 1;
    this.f = 4;
}
($c9361041b5bd802c$var$_.prototype = new $c9361041b5bd802c$export$8210dfe1863c478).h = function() {
    this.f &= -3;
    if (1 & this.f) return !1;
    if (32 == (36 & this.f)) return !0;
    this.f &= -5;
    if (this.g === $c9361041b5bd802c$var$u) return !0;
    this.g = $c9361041b5bd802c$var$u;
    this.f |= 1;
    if (this.i > 0 && !$c9361041b5bd802c$var$l(this)) {
        this.f &= -2;
        return !0;
    }
    var i = $c9361041b5bd802c$var$o;
    try {
        $c9361041b5bd802c$var$y(this);
        $c9361041b5bd802c$var$o = this;
        var t = this.x();
        if (16 & this.f || this.v !== t || 0 === this.i) {
            this.v = t;
            this.f &= -17;
            this.i++;
        }
    } catch (i) {
        this.v = i;
        this.f |= 16;
        this.i++;
    }
    $c9361041b5bd802c$var$o = i;
    $c9361041b5bd802c$var$w(this);
    this.f &= -2;
    return !0;
};
$c9361041b5bd802c$var$_.prototype.S = function(i) {
    if (void 0 === this.t) {
        this.f |= 36;
        for(var t = this.s; void 0 !== t; t = t.n)t.S.S(t);
    }
    $c9361041b5bd802c$export$8210dfe1863c478.prototype.S.call(this, i);
};
$c9361041b5bd802c$var$_.prototype.U = function(i) {
    if (void 0 !== this.t) {
        $c9361041b5bd802c$export$8210dfe1863c478.prototype.U.call(this, i);
        if (void 0 === this.t) {
            this.f &= -33;
            for(var t = this.s; void 0 !== t; t = t.n)t.S.U(t);
        }
    }
};
$c9361041b5bd802c$var$_.prototype.N = function() {
    if (!(2 & this.f)) {
        this.f |= 6;
        for(var i = this.t; void 0 !== i; i = i.x)i.t.N();
    }
};
$c9361041b5bd802c$var$_.prototype.peek = function() {
    if (!this.h()) $c9361041b5bd802c$var$i();
    if (16 & this.f) throw this.v;
    return this.v;
};
Object.defineProperty($c9361041b5bd802c$var$_.prototype, "value", {
    get: function() {
        if (1 & this.f) $c9361041b5bd802c$var$i();
        var t = $c9361041b5bd802c$var$c(this);
        this.h();
        if (void 0 !== t) t.i = this.i;
        if (16 & this.f) throw this.v;
        return this.v;
    }
});
function $c9361041b5bd802c$export$2983e091f1a1e8e2(i) {
    return new $c9361041b5bd802c$var$_(i);
}
function $c9361041b5bd802c$var$g(i) {
    var t = i.u;
    i.u = void 0;
    if ("function" == typeof t) {
        $c9361041b5bd802c$var$v++;
        var n = $c9361041b5bd802c$var$o;
        $c9361041b5bd802c$var$o = void 0;
        try {
            t();
        } catch (t) {
            i.f &= -2;
            i.f |= 8;
            $c9361041b5bd802c$var$b(i);
            throw t;
        } finally{
            $c9361041b5bd802c$var$o = n;
            $c9361041b5bd802c$var$r();
        }
    }
}
function $c9361041b5bd802c$var$b(i) {
    for(var t = i.s; void 0 !== t; t = t.n)t.S.U(t);
    i.x = void 0;
    i.s = void 0;
    $c9361041b5bd802c$var$g(i);
}
function $c9361041b5bd802c$var$x(i) {
    if ($c9361041b5bd802c$var$o !== this) throw new Error("Out-of-order effect");
    $c9361041b5bd802c$var$w(this);
    $c9361041b5bd802c$var$o = i;
    this.f &= -2;
    if (8 & this.f) $c9361041b5bd802c$var$b(this);
    $c9361041b5bd802c$var$r();
}
function $c9361041b5bd802c$var$E(i) {
    this.x = i;
    this.u = void 0;
    this.s = void 0;
    this.o = void 0;
    this.f = 32;
}
$c9361041b5bd802c$var$E.prototype.c = function() {
    var i = this.S();
    try {
        if (8 & this.f) return;
        if (void 0 === this.x) return;
        var t = this.x();
        if ("function" == typeof t) this.u = t;
    } finally{
        i();
    }
};
$c9361041b5bd802c$var$E.prototype.S = function() {
    if (1 & this.f) $c9361041b5bd802c$var$i();
    this.f |= 1;
    this.f &= -9;
    $c9361041b5bd802c$var$g(this);
    $c9361041b5bd802c$var$y(this);
    $c9361041b5bd802c$var$v++;
    var t = $c9361041b5bd802c$var$o;
    $c9361041b5bd802c$var$o = this;
    return $c9361041b5bd802c$var$x.bind(this, t);
};
$c9361041b5bd802c$var$E.prototype.N = function() {
    if (!(2 & this.f)) {
        this.f |= 2;
        this.o = $c9361041b5bd802c$var$f;
        $c9361041b5bd802c$var$f = this;
    }
};
$c9361041b5bd802c$var$E.prototype.d = function() {
    this.f |= 8;
    if (!(1 & this.f)) $c9361041b5bd802c$var$b(this);
};
function $c9361041b5bd802c$export$dc573d8a6576cdb3(i) {
    var t = new $c9361041b5bd802c$var$E(i);
    try {
        t.c();
    } catch (i) {
        t.d();
        throw i;
    }
    return t.d.bind(t);
}


var $f8f19630d13eb642$exports = {};

$parcel$export($f8f19630d13eb642$exports, "newId", function () { return $f8f19630d13eb642$export$9ffd10a3fbdc175b; });
$parcel$export($f8f19630d13eb642$exports, "isObject", function () { return $f8f19630d13eb642$export$a6cdc56e425d0d0a; });
$parcel$export($f8f19630d13eb642$exports, "isArray", function () { return $f8f19630d13eb642$export$43bee75e5e14138e; });
$parcel$export($f8f19630d13eb642$exports, "camelize", function () { return $f8f19630d13eb642$export$161d051f5dd25de7; });
$parcel$export($f8f19630d13eb642$exports, "kebabelize", function () { return $f8f19630d13eb642$export$4909bbd57b1beef8; });
$parcel$export($f8f19630d13eb642$exports, "getIsoDateStr", function () { return $f8f19630d13eb642$export$2c67d5861a969420; });
$parcel$export($f8f19630d13eb642$exports, "defineProperty", function () { return $f8f19630d13eb642$export$fdab3c20aae16ddf; });
$parcel$export($f8f19630d13eb642$exports, "defineReadOnlyProperty", function () { return $f8f19630d13eb642$export$b5c410d4913048d5; });
$parcel$export($f8f19630d13eb642$exports, "tryParse", function () { return $f8f19630d13eb642$export$468ff95b83d315e5; });
$parcel$export($f8f19630d13eb642$exports, "clone", function () { return $f8f19630d13eb642$export$9cd59f9826255e47; });
"use strict";
let $f8f19630d13eb642$var$timeouts = [];
let $f8f19630d13eb642$var$messageName = "zero-timeout-message";
// INFO: https://dbaron.org/log/20100309-faster-timeouts
/**
 * Calls a function in an async manner in as short a timespan as possible
 * @param {function} fn
 */ let $f8f19630d13eb642$var$setZeroTimeout = (fn)=>{
    $f8f19630d13eb642$var$timeouts.push(fn);
    window.postMessage($f8f19630d13eb642$var$messageName, "*");
};
/**
 * Handles postMessages sent to the current window
 * @param {MessageEvent} event
 */ let $f8f19630d13eb642$var$handleZeroTimeoutMessage = (event)=>{
    if (event.source === window && event.data === $f8f19630d13eb642$var$messageName) {
        event.stopPropagation();
        $f8f19630d13eb642$var$timeouts.length && $f8f19630d13eb642$var$timeouts.shift()();
    }
};
if (!window.setZeroTimeout) {
    window.setZeroTimeout = $f8f19630d13eb642$var$setZeroTimeout;
    window.addEventListener("message", $f8f19630d13eb642$var$handleZeroTimeoutMessage, true);
}
let $f8f19630d13eb642$var$uniqueCounter = 0;
let $f8f19630d13eb642$export$9ffd10a3fbdc175b = (prefix = "id_")=>prefix + ++$f8f19630d13eb642$var$uniqueCounter;
let $f8f19630d13eb642$export$a6cdc56e425d0d0a = (obj)=>!!(obj && typeof obj === "object" && !Array.isArray(obj) && obj.contructor !== Date);
let $f8f19630d13eb642$export$43bee75e5e14138e = (obj)=>Array.isArray(obj);
let $f8f19630d13eb642$export$161d051f5dd25de7 = (str)=>str.replace(/-./g, (x)=>x[1].toUpperCase());
let $f8f19630d13eb642$export$4909bbd57b1beef8 = (str)=>str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
let $f8f19630d13eb642$export$2c67d5861a969420 = (date)=>new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().split("T")[0]; // INFO: https://stackoverflow.com/questions/23593052/format-javascript-date-as-yyyy-mm-dd
if (!window.queueMicrotask) window.queueMicrotask = (fn)=>Promise.resolve().then(fn);
/**
 * Define a get/set property on an object
 * @param {object} obj the object
 * @param {string} key the property name
 * @param {any} initialValue the intial value of the property
 * @param {function} callbackOnUpdatedValue
 */ let $f8f19630d13eb642$export$fdab3c20aae16ddf = (obj, key, initialValue, callbackOnUpdatedValue)=>{
    let propName = "$$prop$$" + key.toLowerCase();
    obj[propName] = initialValue;
    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: true,
        get: ()=>obj[propName],
        set (value) {
            let oldValue = obj[propName];
            if (oldValue !== value) {
                obj[propName] = value;
                callbackOnUpdatedValue?.(key, oldValue, value);
            }
        }
    });
};
/**
 * Define a get/set property on an object
 * @param {object} obj the object
 * @param {string} key the property name
 * @param {any} value the value of the property
 */ let $f8f19630d13eb642$export$b5c410d4913048d5 = (obj, key, value)=>{
    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: true,
        get: ()=>value
    });
};
// INFO: https://stackoverflow.com/questions/21485545/is-there-a-way-to-tell-if-an-es6-promise-is-fulfilled-rejected-resolved
let $f8f19630d13eb642$var$makeQueryablePromise = (promise)=>{
    if (promise.isResolved) return promise;
    let isResolved = false;
    let isRejected = false;
    let result = promise.then((v)=>{
        isResolved = true;
        return v;
    }, (e)=>{
        isRejected = true;
        throw e;
    });
    result.isSettled = ()=>isResolved || isRejected;
    result.isResolved = ()=>isResolved;
    result.isRejected = ()=>isRejected;
    return result;
};
/**
 * Try parsing a string as a json object
 * @param {string} str the string to be parsed
 * @returns {Object|Array|String} the parsed object or undefined if unsuccessful
 */ let $f8f19630d13eb642$export$468ff95b83d315e5 = (str)=>{
    try {
        return JSON.parse(str);
    } catch (e) {}
};
let $f8f19630d13eb642$export$9cd59f9826255e47 = (src)=>{
    if ($f8f19630d13eb642$export$43bee75e5e14138e(src)) return src.map((item)=>$f8f19630d13eb642$export$43bee75e5e14138e(item) || $f8f19630d13eb642$export$a6cdc56e425d0d0a(item) ? $f8f19630d13eb642$export$9cd59f9826255e47(item) : item);
    else if (!$f8f19630d13eb642$export$a6cdc56e425d0d0a(src)) return src;
    const cloned = Object.assign({}, src);
    Object.keys(cloned).forEach((key)=>{
        const value = cloned[key];
        if (value) {
            if ($f8f19630d13eb642$export$43bee75e5e14138e(value) || $f8f19630d13eb642$export$a6cdc56e425d0d0a(value)) cloned[key] = $f8f19630d13eb642$export$9cd59f9826255e47(value);
        }
    });
    return cloned;
};


let $b77b30c4d7cb9da3$var$version = "0.9.2";
let { isArray: $b77b30c4d7cb9da3$var$isArray, isObject: $b77b30c4d7cb9da3$var$isObject, defineProperty: $b77b30c4d7cb9da3$var$defineProperty, defineReadOnlyProperty: $b77b30c4d7cb9da3$var$defineReadOnlyProperty, tryParse: $b77b30c4d7cb9da3$var$tryParse, camelize: $b77b30c4d7cb9da3$var$camelize } = $f8f19630d13eb642$exports;
// INFO webcomponent rendering etc.
//      https://open-wc.org/blog/some-things-to-know-when-developing-with-lit/
//      https://open-wc.org/blog/lit-element-deepdive-in-batching-updates/
//      https://open-wc.org/blog/doing-a-flip-with-lit-html-2-0/
//      https://open-wc.org/guides/knowledge/events/
// lit-html templates documentation
//      https://lit.dev/docs/templates/overview/
/** Support events */ let $b77b30c4d7cb9da3$var$events = (0, $8e5676bd73916c78$export$52d98889efa7d412)(Object.create(null));
delete $b77b30c4d7cb9da3$var$events.deEventify;
delete $b77b30c4d7cb9da3$var$events.clearEvents;
let $b77b30c4d7cb9da3$var$noop = ()=>{};
// @ts-check
const $b77b30c4d7cb9da3$var$emptyAttrib = {};
/** @type {import('./lithtmltypes').CustomHTMLElementOptions} */ let $b77b30c4d7cb9da3$var$defaultOptions = {
    useShadowRoot: true,
    renderFrequency: "batched" // raf? immediate? settimeout?
};
/**
 * Base class for new Custom Elements
 */ class $b77b30c4d7cb9da3$var$CustomHTMLElement extends HTMLElement {
    /**
     * @param {typeof import("./lithtmltypes").CustomHTMLElement} derivedClass derived class with potentially observedAttributes and/or observeProperties attached to it
     * @param {import("./lithtmltypes").CustomHTMLElementOptions} options optional CustomHTMLElementOptions
     */ constructor(derivedClass, options = {}){
        super();
        let self = this;
        self.options = Object.assign({}, $b77b30c4d7cb9da3$var$defaultOptions, options);
        /**
         * The name of the custom element
         * @type {string}
         */ self._tag = derivedClass.tag || "missing-tag";
        /**
         * List of all observable properties
         * @type {string[]}
         */ self._obsProps = derivedClass?.observedProperties || [];
        /**
         * List of all the observable attributes.
         * @type {string[]}
         */ self._obsAttrs = derivedClass?.observedAttributes || [];
        // Make sure all observed attributes has a corresponding (observed) property
        self._attrToProps = Object.create(null);
        self._propToAttrs = Object.create(null);
        self._obsAttrs.forEach((attr)=>{
            let propName = $b77b30c4d7cb9da3$var$camelize(attr);
            self._attrToProps[attr] = propName;
            self._propToAttrs[propName] = attr;
            self._obsProps.indexOf(propName) === -1 && self._obsProps.push(propName);
        });
        /** The reason for the current render (mostly interesting for debugging purposes) */ self._renderReason = "";
        /** Indicate wheter the first initial render has been run or not */ self._firstRenderDone = false;
        /** Indicate wheter the first connection to the DOM has been run or not */ self._firstConnectedDone = false;
        /** Indicate wheter a requested async render is in progress or not */ self._requestedAsyncRender = false;
        /**
         * Property used in attributeChangedCallback to help seperate attributes beeing set by
         * calling internal $setAttrib method and beeing set externally by element.setAttribute.
         */ self._newAttribValue = $b77b30c4d7cb9da3$var$emptyAttrib;
        /**
         * List of currently changed properties/attributes that are batched and triggers an onAttributesChanged event
         * @type {import("./lithtmltypes").PropOrAttribChanged[]}
         */ self._chPropOrAttrs = [];
        /** Dictionary of all inital attributes on the element (populated in onFirstConnected) */ self.$attribs = Object.create(null);
        /**
         * Give the derived class the possibility to do some initalizing before setting up observed properties.
         * This can be useful to set the default value of observed properties without them triggering an
         * onPropertyChanged event.
         */ self.initalize?.();
        // Make sure we know when the observed properties are changed so that we can batch trigger a rerender
        // and trigger an onPropertyChanged event
        self._obsProps.forEach((propName)=>self._addReactiveProperty(propName));
    }
    /**
     * Defines a get/set wrapper around a property on the instance
     * @param {string} propName the property name
     */ _addReactiveProperty(propName) {
        let self = this;
        let changedProp = "onChanged_" + propName;
        $b77b30c4d7cb9da3$var$defineProperty(self, propName, self[propName], (propName, oldValue, value)=>{
            self._chPropOrAttrs.push({
                name: propName,
                oldValue: oldValue,
                newValue: value
            });
            self._createRenderTask("observedPropChange");
            self.onPropertyChanged?.(propName, oldValue, value);
            self[changedProp]?.(oldValue, value);
            let attrName = self._propToAttrs[propName];
            if (attrName && !self._attribChangeInProgress) {
                self._propChangeInProgress = true;
                self.$setAttrib(attrName, value);
                self.onAttributeChanged?.(attrName, oldValue, value);
                self._propChangeInProgress = false;
            }
        });
    }
    /**
     * Create a task for rendering. The render is batched, meaning that updating the same property multiple
     * times or updating multiple different properties or attributes will only result in one render beeing called
     * at the end of the code running.
     * @param {string} renderReason description of the reason for calling this method
     */ _createRenderTask(renderReason) {
        let self = this;
        if (self._renderTask) return self._renderTask;
        this._renderReason = this._renderReason || renderReason;
        // Create a (micro)task for batch calling rendering
        self._renderTask = true;
        queueMicrotask(()=>{
            // Check to see if a _renderTask is still active. If ex. a render has just been done, the _renderTask is null
            // and there is no reason to do another render.
            self._renderTask && self._render();
        });
        return this;
    }
    /**
     * Calls the inherited render method and renders the result to DOM. It triggers the
     * shouldRender, willRender and onRendered methods, and the render can be stopped by
     * returning false from the shouldRender method (unless force is specified).
     * @param {boolean} [force] whether the render should be done no matter what
     */ _render(force) {
        let self = this;
        if (self._destroyed) return;
        // Do not render anything before the inital connection to the DOM has run. The reason we're preventing
        // this is that the shadowRoot (if in use) is not created before the initial connectedCallback has run.
        if (!self._firstConnectedDone) {
            self._renderTask = null;
            return;
        }
        let changedPropOrAttribs = self._chPropOrAttrs.splice(0);
        // Allow the component to stop the rendering
        let shouldRender = !force && self.shouldRender && self.shouldRender(changedPropOrAttribs);
        if (!force && shouldRender === false) {
            self._renderTask = null;
            return;
        }
        // Give the component a last change to update properties used in the render
        self.willRender?.(changedPropOrAttribs);
        // Trigger the onFirstRender if not already done
        if (!self._firstRenderDone && self.isConnected) {
            self.onFirstRender?.();
            self.$triggerEvent(self._tag + "-firstrender");
        }
        self._renderTask = null;
        self._chPropOrAttrs.length = 0;
        (0, $0585bced692c3b45$export$b3890eb0ae9dca99)(self.render(self._renderReason), self.shadowRoot || self, {
            host: self
        });
        // Trigger the onFirstRendered if not already done
        if (!self._firstRenderDone && self.isConnected) {
            self._firstRenderDone = true;
            self.onFirstRendered?.();
            self.$triggerEvent(self._tag + "-firstrendered");
        }
        self._renderReason = null;
        // Important that code in onRendered does not trigger a rerender, it's supposed to be
        // used to ex. set focus to an element etc. But in case it happens we try here to convert
        // it to an async render.
        if (self.onRendered) {
            self.onRendered(changedPropOrAttribs);
            if (self._renderTask) {
                self._renderTask = null;
                self.requestAsyncRender("renderRequestInOnRendered");
            }
        }
    }
    /**
     * Trigger and/or dispatch an event
     * @param {string} eventName the name of the event
     * @param {boolean} [dispatch] dispatch an event (default true)
     * @param {boolean} [event] trigger an lithtml event (default true)
     */ $triggerEvent(eventName, { dispatch: dispatch = true, event: event = true, data: data } = {}) {
        let self = this;
        dispatch && self.dispatchEvent(new CustomEvent(eventName, {
            bubbles: true,
            detail: data
        }));
        event && $b77b30c4d7cb9da3$var$events.emit(eventName, ()=>({
                event: eventName,
                target: self,
                id: self.id,
                data: data
            }));
        return self;
    }
    // TODO: https://stackblitz.com/edit/lit-html-script-tag?file=src%2Fscript.js
    /**
     * Force an immediate render, use if a synchronous render is needed.
     */ forceRender(renderReason) {
        this._renderReason = renderReason || "forced";
        this._render(true);
        return this;
    }
    /**
     * Request a microtask-async render, use if some data not in observedAttributes or observedProperties
     * is updated and an update of the DOM is needed.
     * @param {string} [renderReason] info about the reason for rendering (mostly useful for debugging)
     */ requestRender(renderReason) {
        return this._createRenderTask(renderReason || "requested");
    }
    /**
     * Request an async render, use if a 'real' async is needed, and not a microtask async render.
     * @param {string} [renderReason] info about the reason for rendering (mostly useful for debugging)
     */ requestAsyncRender(renderReason) {
        let self = this;
        if (self._requestedAsyncRender) return self;
        self._requestedAsyncRender = true;
        setZeroTimeout(()=>{
            self._createRenderTask(renderReason || "asyncRequested");
            self._requestedAsyncRender = false;
        });
        return self;
    }
    /** Event called when the CustomElement is removed from the DOM */ disconnectedCallback() {
        let self = this;
        let parent = self;
        // If the element still have a parent here, it's probably because the element is beeing moved
        // around the DOM and we'll try to trigger an onMoved event instead of an onDisconnect event
        while(parent.parentElement)parent = parent.parentElement;
        if (parent === document.documentElement) {
            self._justDisconnected = true;
            queueMicrotask(()=>{
                // If still self._justDisconnected that means that connected has not been run,
                // which again means that the this time the element has not been moved but been
                // disconnected for real
                if (self._justDisconnected) {
                    self._justDisconnected = false;
                    self.onDisconnected?.();
                    self.$triggerEvent(self._tag + "-disconnected");
                }
            });
            return;
        }
        self.onDisconnected?.();
        self.$triggerEvent(self._tag + "-disconnected");
    }
    /** Event called when the CustomElement is added/attached to the DOM */ connectedCallback() {
        let self = this;
        // If self._justDisconnected is true this means that the element has been moved instead
        // of having a 'real' disconnect, so we make sure that we trigger a moved event instead
        // of connected.
        if (self._justDisconnected) {
            self._justDisconnected = false;
            self.onMoved?.();
            self.$triggerEvent(self._tag + "-moved");
            return;
        }
        if (!self._firstConnectedDone) {
            self._firstConnectedDone = true;
            // Populate all initial attributes
            self.getAttributeNames().forEach((attrName)=>{
                let propName = $b77b30c4d7cb9da3$var$camelize(attrName);
                self.$attribs[propName] = self[propName] || self.$getValFromString(self.getAttribute(attrName));
            });
            // Create shadowRoot? The default is true, but it can be overridden by using the attribute use-shadow-root.
            //let useShadowRoot = self.$getAttrib('use-shadow-root');
            //if (useShadowRoot === true || useShadowRoot === false) {
            //    self.options.useShadowRoot = useShadowRoot;
            //}
            self.options.useShadowRoot && self.attachShadow({
                mode: "open"
            });
            // If the user is has tried to set the shadowStyle before the shadowRoot is created
            // we now make sure it's set
            if (self._css) {
                self.$setShadowStyle(self._css);
                self._css = null;
            }
            self.onFirstConnected?.();
            self.$triggerEvent(self._tag + "-firstconnected");
            // Make sure we trigger an initial render. After the render has run once, there is no need
            // to trigger a new one each time the element is reconnected, since any changes demanding a
            // render will happen based on prop/attrib changes or specifically calling for it.
            self._createRenderTask("onFirstConnected");
        }
        self.onConnected?.();
        self.$triggerEvent(self._tag + "-connected");
    }
    /** Event called when the CustomElement is adopted (moved from one DOM to another) */ adoptedCallback() {
        let self = this;
        self.$triggerEvent(self._tag + "-adopted");
        self.onAdopted?.();
    }
    /**
     * Event called when an observed attribute changes value
     * @param {string} name the name of the attribute
     * @param {string} oldValue the old value of the attribute
     * @param {string} newValue the new value of the attribute
     */ attributeChangedCallback(name, oldValue, newValue) {
        let self = this;
        if (oldValue === newValue || self._propChangeInProgress) return;
        // We have a backing field for all observed attributes
        let propName = self._attrToProps[name];
        let propFieldName = "$$prop$$" + (propName || "").toLowerCase();
        // Get the correct old value
        if (propFieldName in self) oldValue = self[propFieldName];
        // Get the 'correct' newValue based on it coming from .setAttribute or $setAttrib
        newValue = self._newAttribValue !== $b77b30c4d7cb9da3$var$emptyAttrib ? self._newAttribValue : self.$getValFromString(newValue);
        if (oldValue === newValue) return;
        self._createRenderTask("observedAttribChange");
        self.onAttributeChanged?.(name, oldValue, newValue);
        // Setting the property here will trigger an onPropertyChanged event which will
        // also make sure the _chPropOrAttrs array gets updated
        self._attribChangeInProgress = true;
        propName && (self[propName] = newValue);
        self._attribChangeInProgress = false;
    }
    /**
     * The render method, called each time the custom element needs to be updated/rendered
     * @param {string} renderReason the reason for the render beeing called
     * @returns {import("./types/lit-html").TemplateResult} the template to be rendered
     * */ render(renderReason) {
        return 0, $0585bced692c3b45$export$45b790e32b2810ee;
    }
    /** Destroys the element */ destroy() {
        let self = this;
        if (self._destroyed) return;
        self._destroyed = true;
        self.onDestroy?.();
        self._newAttribValue = null;
        self.options = null;
        self._obsAttrs.length = 0;
        self._obsAttrs = null;
        self._chPropOrAttrs.length = 0;
        self._chPropOrAttrs = null;
        self._obsProps.forEach((prop)=>{
            delete self["$$prop$$" + prop.toLowerCase()];
            delete self[prop];
        });
        self._obsProps.length = 0;
        self._obsProps = null;
        self._attrToProps = null;
        self._propToAttrs = null;
        self._css = null;
        self.$attribs = null;
        self.parentElement?.removeChild(self);
        self.render = ()=>(0, $0585bced692c3b45$export$45b790e32b2810ee);
        self.$triggerEvent(self._tag + "-destroyed", {
            dispatch: false
        });
    }
    /**
     * Appends an eventlistener (this is a wrapper around addEventListener)
     * @param {string} eventName the event to react to
     * @param {EventListenerOrEventListenerObject} callback the event handler
     * @param {boolean|AddEventListenerOptions|undefined} [options] options
     * @returns {CustomHTMLElement}
     */ on(eventName, callback, options) {
        this.addEventListener(eventName, callback, options);
        return this;
    }
    /**
     * Removes an eventlistener (this is a wrapper around removeEventListener)
     * @param {string} eventName
     * @param {EventListenerOrEventListenerObject} callback
     * @param {boolean|AddEventListenerOptions|undefined} options
     * @returns {CustomHTMLElement}
     */ off(eventName, callback, options) {
        this.removeEventListener(eventName, callback, options);
        return this;
    }
    /**
     * Gets the value of an attribute. The value returned is the string converted value, which can be string, number, boolean, object, array, ...
     * @param {string} attr the attribute name
     * @returns {any} the attribute value
     */ $getAttrib(attr) {
        let self = this;
        // If the attribute is also a property where we use get/set then make sure we return
        // the 'real' value of the attribute, and not just the string representation (attributes are always strings).
        let propName = $b77b30c4d7cb9da3$var$camelize(attr);
        if (self._obsProps.indexOf(propName) !== -1) return self[propName];
        //        if (attr in self) {
        //window.console.log('$getAttrib', attr, '- in self')
        //            return self[attr];
        //        }
        return self.$getValFromString(self.getAttribute(attr));
    }
    /**
     * Sets an attribute value
     * @param {string} attr the attribute name
     * @param {any} val the value of the attribute
     */ $setAttrib(attr, val) {
        let self = this;
        let propName = "$$prop$$" + (self._attrToProps[attr] || "").toLowerCase();
        // If the attribute is also an observed attribute/property then make sure we keep
        // the 'real' value of the attribute, and not just the string representation (attributes are always strings).
        self._newAttribValue = propName in self ? val : $b77b30c4d7cb9da3$var$emptyAttrib;
        // NB! Calling set/remove-Attribute here triggers an attributeChangedCallback for
        //     observed attributes, which is the reason we set the _newAttribValue so that the
        //     callback can differentiate between internal set attributes and external.
        if (!val && val !== false) self.removeAttribute(attr);
        else $b77b30c4d7cb9da3$var$isObject(val) || $b77b30c4d7cb9da3$var$isArray(val) ? self.setAttribute(attr, JSON.stringify(val)) : self.setAttribute(attr, val);
        self._newAttribValue = $b77b30c4d7cb9da3$var$emptyAttrib;
        return self;
    }
    /**
     * Tries to convert a string to it's correct type
     * @param {string} val the string to be converted
     */ $getValFromString(val) {
        if (!val) return val;
        if (val[0] === "{") {
            if (val !== "{}" && val.indexOf(":") === -1) return val;
            return $b77b30c4d7cb9da3$var$tryParse(val) || val;
        }
        if (val[0] === "[") return $b77b30c4d7cb9da3$var$tryParse(val) || val;
        let number = parseFloat(val);
        if (!isNaN(number)) return number;
        return val === "true" ? true : val === "false" ? false : val === "null" ? null : val === "undefined" ? undefined : val;
    }
    /**
     * Sets the styling of the element
     * @param {string} css the css
     */ $setShadowStyle(css) {
        let self = this;
        // Need to make sure that the shadowRoot exists, which has happened when firstConnected is called
        if (!self._firstConnectedDone) {
            self._css = css;
            return self;
        }
        if (!self.shadowRoot) throw {
            message: "Can only use $setShadowStyle on web component using shadowRoot"
        };
        css = css.replace("<style>", "").replace("</style>", "");
        // Use adoptedStyleSheets?
        //  INFO:
        //      https://github.com/lit/lit/blob/00b8c56422fc2577e265393cec6726a4e71a561f/packages/reactive-element/src/css-tag.ts#L99
        //      https://developer.mozilla.org/en-US/docs/Web/API/Document/adoptedStyleSheets
        //      https://web.dev/constructable-stylesheets/
        if ("adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype) {
            let sheet = new CSSStyleSheet();
            sheet.replaceSync(css);
            self.shadowRoot.adoptedStyleSheets = [
                sheet
            ];
        } else {
            let style = document.createElement("style");
            style.textContent = css;
            self.shadowRoot.appendChild(style);
        }
        return self;
    }
}
class $b77b30c4d7cb9da3$var$CustomTokenHTMLElement extends $b77b30c4d7cb9da3$var$CustomHTMLElement {
    /**
     * Constructor
     */ constructor(DerivedClass, options){
        super(DerivedClass, options);
        let self = this;
        self._addReactiveProperty("userData");
        self._checkForUserInfoAndToken = self._checkForUserInfoAndToken.bind(self);
    }
    /**
     * Callback called when the custom element has been connected to the DOM for the first time
     * NB! Inherited Custom Elements *must* call super.onFirstConencted() if overriding this method
     */ onFirstConnected() {
        this._checkForUserInfoAndToken();
    }
    /**
     * Called when destroy has been called on the element, so we do some cleanup
     * NB! Inherited Custom Elements *must* call super.onDestroy() if overriding this method
     */ onDestroy() {
        let self = this;
        self._timeoutTokenId && clearTimeout(self._timeoutTokenId);
        self._timeoutTokenId = null;
    }
    /**
     * Make sure that we do not stop asking for userinfo and token until we get them. We do this
     * in case the user attaches an eventlistener for the 'needUserInfoAndToken' event after the
     * html element is attached to the DOM. The events bubble, so this can easily be avoided by
     * ex. attaching the eventlistener on the document (which will then automatically also work
     * for dynamically added elements)
     */ _checkForUserInfoAndToken() {
        let self = this;
        if (self.userData) return;
        if (self._checkedNoOfTimes > 10) return;
        self._checkedNoOfTimes = self._checkedNoOfTimes || 0;
        self._checkedNoOfTimes++;
        self.$triggerEvent("web-component-needUserInfoAndToken");
        setTimeout(self._checkForUserInfoAndToken, 25);
    }
    /**
     * Updated the userinfo and token
     */ updateUserInfoAndToken(tokenAndUserInfo) {
        if (!tokenAndUserInfo.accessToken) {
            window["console"].log("Missing accesstoken");
            return;
        }
        let self = this;
        let token = JSON.parse(window.atob(tokenAndUserInfo.accessToken.split(".")[1]));
        tokenAndUserInfo.identity = tokenAndUserInfo.userInfo;
        self.userData = tokenAndUserInfo;
        self.onUserData?.(self.userData);
        // Make sure we request a new updated token token when the current one is about to expire
        let now = parseInt(Date.now() / 1000);
        let timeoutInSec = token.exp - now - 10;
        //
        if (timeoutInSec <= 0) timeoutInSec = 20;
        self._timeoutTokenId && clearTimeout(self._timeoutTokenId);
        self._timeoutTokenId = setTimeout(()=>self.$triggerEvent("web-component-needUserInfoAndToken"), timeoutInSec * 1000);
    }
}
/**
 * Parses a string template and converts it to a TemplateResult calling function, of which the
 * result can be used in the render function
 * @type {typeof import('./lithtmltypes').CreateTemplateFn}
 */ let $b77b30c4d7cb9da3$var$createTemplateFn = (strTemplate, options)=>{
    let { context: context, contextParams: contextParams, thisContext: thisContext } = options || {};
    let templateFn = new Function("lithtml", "$context", `
        let { ${(contextParams || []).join(",")} } = $context;
        let { nothing,noChange,html,svg,repeat,cache,choose,classMap,guard,ifDefined,join,keyed,live,map,range,ref,createRef,styleMap,until,when,asyncAppend,asyncReplace,templateContent,unsafeHTML,unsafeSVG,createTemplateFn,utils,virtualize,virtualizerRef } = lithtml;
        return html${"`" + strTemplate + "`"};`);
    if (thisContext) templateFn = templateFn.bind(thisContext);
    return (ctx)=>templateFn($b77b30c4d7cb9da3$var$lithtml, ctx || context || {});
};
/**
 * Takes a template string and optional context/data and renders the template to a DocumentFragment
 * @type {typeof import('./lithtmltypes').renderStrToEl}
 */ let $b77b30c4d7cb9da3$var$renderStrToEl = (strTemplate, options)=>{
    let htmlFn = $b77b30c4d7cb9da3$var$createTemplateFn(strTemplate, options);
    let target = new DocumentFragment();
    (0, $0585bced692c3b45$export$b3890eb0ae9dca99)(htmlFn(), target);
    return target;
};
/**
 * Takes a template string and optional context/data and renders the template to a string
 * @type {typeof import('./lithtmltypes').RenderStrToHtmlFn}
 */ let $b77b30c4d7cb9da3$var$renderStrToHtml = (strTemplate, options)=>{
    let fragment = $b77b30c4d7cb9da3$var$renderStrToEl(strTemplate, options);
    let tempEl = document.createElement("script");
    tempEl.type = "text/html";
    tempEl.appendChild(fragment);
    return tempEl.innerHTML.trim().replaceAll(/\x3C![^>]*>/gi, "");
};
/**
 * Add translations recursively to the root of the translation object
 * @param {string} prefix the prefix added in fron of the translation keys (ex. '', 'Status.', ...)
 * @param {object} langObj the object containing the language translations
 * @param {object} translationObj the resulting translation object
 * @param {number} [index] optional index into the array of translations
 */ let $b77b30c4d7cb9da3$var$addLanguageRec = (prefix, langObj, translationObj, index = -1)=>{
    Object.keys(langObj).forEach((key)=>{
        let text = langObj[key];
        if ($b77b30c4d7cb9da3$var$isObject(text)) $b77b30c4d7cb9da3$var$addLanguageRec(prefix + key + ".", text, translationObj, index);
        else translationObj[prefix + key] = index === -1 ? text : text[index];
    });
};
/**
 * Initializes a new translations function
 * @param tagOrBaseTranslationUrl [string] the tag or the base url for language json files that may be downloaded
 * @param version [string=] the tag version
 */ let $b77b30c4d7cb9da3$var$translateInit = (tagOrBaseTranslationUrl, version)=>{
    let translations = Object.create(null);
    let currTranslation = defTranslation = translations;
    let translationBaseUrl;
    if (version) translationBaseUrl = `https://cdnpowel.azureedge.net/scripts/webcomponents/${tagOrBaseTranslationUrl}/${version}`;
    else if (tagOrBaseTranslationUrl) translationBaseUrl = tagOrBaseTranslationUrl;
    /** @type{import('./lithtmltypes').TranslateFunc} */ let t = (key)=>currTranslation[key] || defTranslation[key] || key;
    t.add = (lang, data)=>{
        let langName;
        if (typeof lang === "string") {
            langName = lang;
            $b77b30c4d7cb9da3$var$addLanguageRec("", data, translations[lang] || (translations[lang] = Object.create(null)));
        } else if ($b77b30c4d7cb9da3$var$isArray(lang)) {
            langName = lang[0];
            lang.forEach((langName, index)=>$b77b30c4d7cb9da3$var$addLanguageRec("", data, translations[langName] || (translations[langName] = Object.create(null)), index));
        } else if ($b77b30c4d7cb9da3$var$isObject(lang)) {
            langName = Object.keys(lang)[0];
            Object.keys(lang).forEach((langName)=>$b77b30c4d7cb9da3$var$addLanguageRec("", lang[langName], translations[langName] = Object.create(null)));
        }
        // Set default language if not already done
        let globalLang = translations[$b77b30c4d7cb9da3$var$lithtml.translation.language];
        if (globalLang) {
            if (currTranslation === translations) currTranslation = globalLang;
            if (defTranslation === translations) defTranslation = globalLang;
        }
        // Make sure we do have a translation in case the global translation is missing
        if (currTranslation === translations) currTranslation = defTranslation = translations[langName];
        return t;
    };
    t.defTranslation = (langName)=>{
        let translationToUse = translations[langName];
        if (translationToUse) defTranslation = translationToUse;
        return t;
    };
    t.useLang = (langName)=>{
        let translationToUse = translations[langName];
        if (translationToUse) {
            currTranslation = translationToUse;
            if (defTranslation === translations) defTranslation = currTranslation;
        }
        return t;
    };
    t.load = (langName)=>{
        if (translations[langName]) {
            t.useLang(langName);
            return Promise.resolve();
        }
        if (!translationBaseUrl) return Promise.resolve();
        return fetch(`${translationBaseUrl}/${langName}.json`).then((response)=>{
            if (response.ok) return response.json();
        }).then((data)=>{
            if (data) t.add(langName, data).useLang(langName);
            return data;
        });
    };
    t.setTranslation = (langObj)=>{
        currTranslation = langObj;
        return t;
    };
    t.destroy = ()=>{
        translations = Object.create(null);
        currTranslation = null;
        defTranslation = null;
    };
    return t;
};
/** The global lithtml object */ let $b77b30c4d7cb9da3$var$lithtml = Object.create($b77b30c4d7cb9da3$var$events);
/** The current language */ let $b77b30c4d7cb9da3$var$currLanguage = (location.href.split("lang=")[1] || "").substring(0, 2);
if (!$b77b30c4d7cb9da3$var$currLanguage) $b77b30c4d7cb9da3$var$currLanguage = window.appContext?.language;
if (!$b77b30c4d7cb9da3$var$currLanguage) try {
    $b77b30c4d7cb9da3$var$currLanguage = localStorage.getItem("lang");
} catch (e) {}
if (!$b77b30c4d7cb9da3$var$currLanguage) $b77b30c4d7cb9da3$var$currLanguage = "en";
$b77b30c4d7cb9da3$var$lithtml.render = (0, $0585bced692c3b45$export$b3890eb0ae9dca99);
$b77b30c4d7cb9da3$var$lithtml.nothing = (0, $0585bced692c3b45$export$45b790e32b2810ee);
$b77b30c4d7cb9da3$var$lithtml.noChange = (0, $0585bced692c3b45$export$9c068ae9cc5db4e8);
$b77b30c4d7cb9da3$var$lithtml.html = (0, $0585bced692c3b45$export$c0bb0b647f701bb5);
$b77b30c4d7cb9da3$var$lithtml.svg = (0, $0585bced692c3b45$export$7ed1367e7fa1ad68);
$b77b30c4d7cb9da3$var$lithtml.repeat = (0, $2d06e2ab5b695b60$export$76d90c956114f2c2);
$b77b30c4d7cb9da3$var$lithtml.cache = (0, $77f5167d06bc2fde$export$69a3209f1a06c04d);
$b77b30c4d7cb9da3$var$lithtml.choose = (0, $7b7b9a37160c97db$export$7877a478dd30fd3d);
$b77b30c4d7cb9da3$var$lithtml.classMap = (0, $e4437dd0216a4379$export$56cc687933817664);
$b77b30c4d7cb9da3$var$lithtml.guard = (0, $0100bfbf2c1b33f3$export$864d727b48066337);
$b77b30c4d7cb9da3$var$lithtml.ifDefined = (0, $49f9812d6d4b3bb6$export$f68dd208b5df064d);
$b77b30c4d7cb9da3$var$lithtml.join = (0, $0d7955f0662edf92$export$f7e2c8231c57a8bd);
$b77b30c4d7cb9da3$var$lithtml.keyed = (0, $ef64bd03c02e190d$export$8dbf9c790527241e);
$b77b30c4d7cb9da3$var$lithtml.live = (0, $2ed4c26e5fc1311e$export$28cf49ad70f82d12);
$b77b30c4d7cb9da3$var$lithtml.map = (0, $efb58c27b85b03fa$export$871de8747c9eaa88);
$b77b30c4d7cb9da3$var$lithtml.range = (0, $b0f47510656516d3$export$d02631cccf789723);
$b77b30c4d7cb9da3$var$lithtml.ref = (0, $65d76be7707749f6$export$eff4d24c3ff7876e);
$b77b30c4d7cb9da3$var$lithtml.createRef = (0, $65d76be7707749f6$export$7d1e3a5e95ceca43);
$b77b30c4d7cb9da3$var$lithtml.styleMap = (0, $22f699b0009eb85b$export$1e5b4ce2fa884e6a);
$b77b30c4d7cb9da3$var$lithtml.until = (0, $04babc6848c3c9b3$export$a40009bd2c363351);
$b77b30c4d7cb9da3$var$lithtml.when = (0, $d2deeaf9cd169c53$export$a55877ca9db47377);
$b77b30c4d7cb9da3$var$lithtml.asyncAppend = (0, $82e12a832c7dc237$export$eaa89ade56b7c0c1);
$b77b30c4d7cb9da3$var$lithtml.asyncReplace = (0, $9a7b48e7039d5564$export$662eef59ff6bd56a);
$b77b30c4d7cb9da3$var$lithtml.templateContent = (0, $9a609a3f11152775$export$e446d0492332fcd4);
$b77b30c4d7cb9da3$var$lithtml.unsafeHTML = (0, $0a9d83bb2173ec99$export$b6e69390c23686fb);
$b77b30c4d7cb9da3$var$lithtml.unsafeSVG = (0, $378ddd6808e465bc$export$1cb98903879b8bf5);
//lithtml.virtualize      = virtualize     ;
//lithtml.virtualizerRef  = virtualizerRef ;
$b77b30c4d7cb9da3$var$lithtml.CustomHTMLElement = $b77b30c4d7cb9da3$var$CustomHTMLElement;
$b77b30c4d7cb9da3$var$lithtml.CustomTokenHTMLElement = $b77b30c4d7cb9da3$var$CustomTokenHTMLElement;
$b77b30c4d7cb9da3$var$lithtml.utils = $f8f19630d13eb642$exports;
/**
 * preact signals
 * @type {import('./lithtmltypes').Signals}
 */ $b77b30c4d7cb9da3$var$lithtml.signals = {
    signal: $c9361041b5bd802c$export$e2ef10f86a8d60e8,
    batch: $c9361041b5bd802c$export$712ea50be43a7858,
    computed: $c9361041b5bd802c$export$2983e091f1a1e8e2,
    effect: $c9361041b5bd802c$export$dc573d8a6576cdb3,
    subscribe: (signalOrSignals, cb, { runOnSubscribe: runOnSubscribe, batchCallback: batchCallback } = {})=>{
        let signals = $b77b30c4d7cb9da3$var$isArray(signalOrSignals) ? signalOrSignals : [
            signalOrSignals
        ];
        let firstRun = true;
        let batching = false;
        return (0, $c9361041b5bd802c$export$dc573d8a6576cdb3)(()=>{
            signals.forEach((signal)=>signal.value);
            // Callback immediately after calling subscribe?
            if (firstRun) {
                firstRun = false;
                if (!runOnSubscribe) return;
            }
            // If no batching, run callback immediately on every signal change
            if (!batchCallback) {
                cb(signals);
                return;
            }
            if (batching) return;
            // TODO: call dispose here? and subscribe again in the resolved promise? maybe a problem with code that keeps track of the dispose function... --> could be solved with returning an object with dispose in? no need for 'batching' variable.
            batching = true;
            queueMicrotask(()=>{
                cb(signals);
                batching = false;
            });
        });
    }
};
/**
 * @type {import('./lithtmltypes').Translation}
 */ $b77b30c4d7cb9da3$var$lithtml.translation = {
    get language () {
        return $b77b30c4d7cb9da3$var$currLanguage;
    },
    init: $b77b30c4d7cb9da3$var$translateInit,
    useLang: (langName)=>{
        if (langName && $b77b30c4d7cb9da3$var$currLanguage !== langName) {
            $b77b30c4d7cb9da3$var$currLanguage = langName;
            $b77b30c4d7cb9da3$var$lithtml.emit("language-changed", {
                lang: $b77b30c4d7cb9da3$var$currLanguage
            });
        }
    }
};
let $b77b30c4d7cb9da3$var$stateObj = (0, $8e5676bd73916c78$export$52d98889efa7d412)(Object.create(null));
delete $b77b30c4d7cb9da3$var$stateObj.deEventify;
delete $b77b30c4d7cb9da3$var$stateObj.clearEvents;
$b77b30c4d7cb9da3$var$defineReadOnlyProperty($b77b30c4d7cb9da3$var$lithtml, "state", Object.create($b77b30c4d7cb9da3$var$stateObj));
$b77b30c4d7cb9da3$var$lithtml.createTemplateFn = $b77b30c4d7cb9da3$var$createTemplateFn;
$b77b30c4d7cb9da3$var$lithtml.renderStrToHtml = $b77b30c4d7cb9da3$var$renderStrToHtml;
$b77b30c4d7cb9da3$var$lithtml.renderStrToEl = $b77b30c4d7cb9da3$var$renderStrToEl;
$b77b30c4d7cb9da3$var$lithtml.eventify = (0, $8e5676bd73916c78$export$52d98889efa7d412);
$b77b30c4d7cb9da3$var$lithtml.version = $b77b30c4d7cb9da3$var$version;
if (!window.lithtml || window.lithtml.version < $b77b30c4d7cb9da3$var$lithtml.version) window.lithtml = $b77b30c4d7cb9da3$var$lithtml;
 // Copy this for module min build
 //export const { render, nothing, noChange, html, svg, repeat, cache, choose, classMap, guard, ifDefined, join, keyed, live, map, range, ref, createRef, styleMap, until, when, asyncAppend, asyncReplace, templateContent, unsafeHTML, unsafeSVG, CustomHTMLElement, createTemplateFn, eventify, version, emitOnce, emitAsync, emit, once, off, on } = lithtml;
 // Use this for buildtest
 //export { render, nothing, noChange, html, svg, repeat, cache, choose, classMap, guard, ifDefined, join, keyed, live, map, range, ref, createRef, styleMap, until, when, asyncAppend, asyncReplace, templateContent, unsafeHTML, unsafeSVG, CustomHTMLElement };
 /*
    Example of generating dynamic html with lithtml

        let a = document.createElement('div');
        let b = lithtml.createTemplateFn('<b>test ${this.location.href}</b>', { thisContext: window });
        lithtml.render(b(), a);
        a.innerHTML;


        lithtml.render(lithtml.html`<b>testcccccc</b>`, document.body)



*/ 

})();
//# sourceMappingURL=lithtml.js.map
